"use strict";
export const validate = validate10;
export default validate10;
const schema11 = { "type": "object", "properties": { "layoutParams": { "$ref": "#/definitions/LayoutParams" }, "behaviourParams": { "$ref": "#/definitions/BehaviourParams" }, "stylingParams": { "$ref": "#/definitions/StylingParams" } }, "definitions": { "LayoutParams": { "type": "object", "properties": { "groups": { "$ref": "#/definitions/Groups" }, "crop": { "$ref": "#/definitions/Crop" }, "structure": { "$ref": "#/definitions/Structure" }, "thumbnails": { "$ref": "#/definitions/Thumbnails" }, "navigationArrows": { "$ref": "#/definitions/NavigationArrows" }, "info": { "$ref": "#/definitions/Info" }, "targetItemSize": { "$ref": "#/definitions/TargetItemSize" } } }, "Groups": { "type": "object", "properties": { "density": { "type": "number" }, "groupByOrientation": { "type": "boolean" }, "numberOfGroupsPerRow": { "type": "number" }, "allowedGroupTypes": { "type": "array", "items": { "enum": ["1", "2h", "2v", "3b", "3h", "3l", "3r", "3t", "3v"], "type": "string" } }, "repeatingGroupTypes": { "type": "array", "items": { "enum": ["1", "2h", "2v", "3b", "3h", "3l", "3r", "3t", "3v"], "type": "string" } }, "groupSize": { "type": "number" } } }, "Crop": { "type": "object", "properties": { "method": { "enum": ["FILL", "FIT", "MAX", "MIN"], "type": "string" }, "alignment": { "enum": ["BOTTOM", "CENTER", "LEFT", "RIGHT", "TOP"], "type": "string" }, "enable": { "type": "boolean" }, "enableSmartCrop": { "type": "boolean" }, "cropOnlyFill": { "type": "boolean" }, "ratios": { "type": "array", "items": { "type": "number" } } } }, "Structure": { "type": "object", "properties": { "galleryLayout": { "type": "number" }, "galleryRatio": { "$ref": "#/definitions/GalleryRatio" }, "enableStreching": { "type": "boolean" }, "gallerySpacing": { "type": "number" }, "itemSpacing": { "type": "number" }, "scrollDirection": { "enum": ["HORIZONTAL", "VERTICAL"], "type": "string" }, "numberOfColumns": { "type": "number" }, "numberOfGridRows": { "type": "number" }, "responsiveMode": { "enum": ["FIT_TO_SCREEN", "SET_ITEMS_PER_ROW"], "type": "string" }, "columnRatios": { "type": "array", "items": { "type": "number" } }, "scatter": { "$ref": "#/definitions/Scatter" }, "layoutOrientation": { "enum": ["HORIZONTAL", "VERTICAL"], "type": "string" }, "groupsOrder": { "enum": ["BY_HEIGHT", "LEFT_TO_RIGHT"], "type": "string" } } }, "GalleryRatio": { "type": "object", "properties": { "value": { "type": "number" }, "includeExternalInfo": { "type": "boolean" } }, "required": ["includeExternalInfo", "value"] }, "Scatter": { "type": "object", "properties": { "randomScatter": { "type": "number" }, "manualScatter": { "type": "string" } } }, "Thumbnails": { "type": "object", "properties": { "enable": { "type": "boolean" }, "position": { "enum": ["ON_GALLERY", "OUTSIDE_GALLERY"], "type": "string" }, "spacing": { "type": "number" }, "marginToGallery": { "type": "number" }, "size": { "type": "number" }, "alignment": { "enum": ["BOTTOM", "LEFT", "RIGHT", "TOP"], "type": "string" } } }, "NavigationArrows": { "type": "object", "properties": { "enable": { "type": "boolean" }, "size": { "type": "number" }, "padding": { "type": "number" }, "position": { "enum": ["MOUSE_CURSOR", "ON_GALLERY", "OUTSIDE_GALLERY"], "type": "string" }, "verticalAlignment": { "enum": ["IMAGE_CENTER", "INFO_CENTER", "ITEM_CENTER"], "type": "string" }, "type": { "enum": ["ARROW_2", "ARROW_3", "DEFAULT_ARROW"], "type": "string" }, "container": { "$ref": "#/definitions/NavigationArrowsContainer" }, "mouseCursorContainerMaxWidth": { "type": "number" } } }, "NavigationArrowsContainer": { "type": "object", "properties": { "type": { "enum": ["BOX", "NONE", "SHADOW"], "type": "string" }, "borderRadius": { "type": "number" }, "backgroundColor": { "type": "string" } } }, "Info": { "type": "object", "properties": { "sizeUnits": { "enum": ["PERCENT", "PIXEL"], "type": "string" }, "width": { "type": "number" }, "height": { "type": "number" }, "spacing": { "type": "number" }, "layout": { "enum": ["ATTACHED_BACKGROUND", "DONT_SHOW", "NO_BACKGROUND", "SEPARATED_BACKGROUND"], "type": "string" }, "border": { "$ref": "#/definitions/InfoBorder" }, "placement": { "enum": ["ABOVE", "ALTERNATE_HORIZONTALLY", "ALTERNATE_VERTICALLY", "BELOW", "LEFT", "OVERLAY", "RIGHT"], "type": "string" } } }, "InfoBorder": { "type": "object", "properties": { "width": { "type": "number" }, "color": { "type": "string" }, "radius": { "type": "number" } } }, "TargetItemSize": { "type": "object", "properties": { "unit": { "enum": ["PERCENT", "PIXEL", "SMART"], "type": "string" }, "value": { "type": "number" }, "minimum": { "type": "number" } } }, "BehaviourParams": { "type": "object", "properties": { "item": { "$ref": "#/definitions/Item" }, "gallery": { "$ref": "#/definitions/Gallery" } } }, "Item": { "type": "object", "properties": { "clickAction": { "enum": ["ACTION", "LINK", "MAGNIFY", "NOTHING"], "type": "string" }, "video": { "$ref": "#/definitions/Video" }, "threeDimensionalScene": { "$ref": "#/definitions/ThreeDimensionalScene" }, "overlay": { "$ref": "#/definitions/Overlay" }, "content": { "$ref": "#/definitions/Content" }, "secondaryMedia": { "$ref": "#/definitions/SecondaryMedia" } } }, "Video": { "type": "object", "properties": { "speed": { "type": "number" }, "volume": { "type": "number" }, "loop": { "type": "boolean" }, "playTrigger": { "enum": ["AUTO", "CLICK", "HOVER"], "type": "string" }, "enablePlayButton": { "type": "boolean" }, "enableThumbnailsPlayButton": { "type": "boolean" }, "enableControls": { "type": "boolean" }, "enablePlaceholder": { "type": "boolean" } } }, "ThreeDimensionalScene": { "type": "object", "properties": { "transform": { "$ref": "#/definitions/Transform" }, "controls": { "$ref": "#/definitions/Controls" }, "enablePlayButton": { "type": "boolean" }, "enableThumbnailsPlayButton": { "type": "boolean" }, "playTrigger": { "enum": ["AUTO", "CLICK", "HOVER"], "type": "string" } } }, "Transform": { "type": "object", "properties": { "rotation": { "type": "string" }, "scale": { "type": "string" }, "position": { "type": "string" } } }, "Controls": { "type": "object", "properties": { "enableZoom": { "type": "boolean" }, "enableRotate": { "type": "boolean" }, "enablePan": { "type": "boolean" }, "enableAutoRotate": { "type": "boolean" } } }, "Overlay": { "type": "object", "properties": { "hoveringBehaviour": { "enum": ["ALWAYS_SHOW", "APPEARS", "DISAPPEARS", "NEVER_SHOW"], "type": "string" }, "hoverAnimation": { "enum": ["EXPAND", "FADE_IN", "NO_EFFECT", "SLIDE_DOWN", "SLIDE_LEFT", "SLIDE_RIGHT", "SLIDE_UP"], "type": "string" }, "position": { "enum": ["BUTTOM", "CENTERED_HORIZONTALLY", "CENTERED_VERTICALLY", "LEFT", "RIGHT", "TOP"], "type": "string" }, "size": { "type": "number" }, "sizeUnits": { "enum": ["PERCENT", "PIXEL"], "type": "string" }, "padding": { "type": "number" }, "backgroundColor": {} } }, "Content": { "type": "object", "properties": { "hoverAnimation": { "enum": ["BLUR", "COLOR_IN", "DARKENED", "GRAYSCALE", "INVERT", "NO_EFFECT", "SHRINK", "TILT", "ZOOM_IN"], "type": "string" }, "placementAnimation": { "enum": ["NO_EFFECT", "SLIDE"], "type": "string" }, "loader": { "enum": ["BLUR", "COLOR", "MAIN_COLOR"], "type": "string" }, "magnificationValue": { "type": "number" }, "tiltAngleValue": { "type": "number" } } }, "SecondaryMedia": { "type": "object", "properties": { "trigger": { "enum": ["HOVER", "OFF"], "type": "string" }, "behaviour": { "type": "string", "const": "APPEARS" } }, "required": ["behaviour", "trigger"] }, "Gallery": { "type": "object", "properties": { "layoutDirection": { "enum": ["LEFT_TO_RIGHT", "RIGHT_TO_LEFT"], "type": "string" }, "blockContextMenu": { "type": "boolean" }, "scrollAnimation": { "enum": ["BLUR", "EXPAND", "FADE_IN", "GRAYSCALE", "MAIN_COLOR", "NO_EFFECT", "ONE_COLOR", "SHRINK", "SLIDE_UP", "ZOOM_OUT"], "type": "string" }, "enableIndexingShareLinks": { "type": "boolean" }, "vertical": { "$ref": "#/definitions/Vertical" }, "horizontal": { "$ref": "#/definitions/Horizontal" } } }, "Vertical": { "type": "object", "properties": { "loadMore": { "$ref": "#/definitions/LoadMore" } } }, "LoadMore": { "type": "object", "properties": { "enable": { "type": "boolean" }, "amount": { "enum": ["ALL", "PARTIAL"], "type": "string" }, "text": { "type": "string" } } }, "Horizontal": { "type": "object", "properties": { "enableScrollSnap": { "type": "boolean" }, "slideAnimation": { "enum": ["DECK", "FADE", "SCROLL"], "type": "string" }, "slideTransition": { "type": "string" }, "blockScroll": { "type": "boolean" }, "navigationDuration": { "type": "number" }, "loop": { "type": "boolean" }, "autoSlide": { "$ref": "#/definitions/AutoSlide" }, "slideshowInfo": { "$ref": "#/definitions/SlideshowInfo" } } }, "AutoSlide": { "type": "object", "properties": { "behaviour": { "enum": ["CONTINUOUS", "INTERVAL", "OFF"], "type": "string" }, "interval": { "type": "number" }, "pauseOnHover": { "type": "boolean" }, "speed": { "type": "number" } } }, "SlideshowInfo": { "type": "object", "properties": { "buttonsAlignment": { "enum": ["CENTER", "LEFT", "RIGHT"], "type": "string" }, "enableCounter": { "type": "boolean" }, "enablePlayButton": { "type": "boolean" } } }, "StylingParams": { "type": "object", "properties": { "arrowsColor": { "type": "string" }, "itemShadowBlur": { "type": "number" }, "itemShadowDirection": { "type": "number" }, "itemShadowOpacityAndColor": { "type": "string" }, "itemShadowSize": { "type": "number" }, "itemEnableShadow": { "type": "boolean" }, "itemBorderRadius": { "type": "number" }, "itemBorderWidth": { "type": "number" }, "itemBorderColor": {}, "itemResolutionMode": { "enum": ["FULL", "SCLAED_DOWN"], "type": "string" } } } }, "$schema": "http://json-schema.org/draft-07/schema#" };
const schema39 = { "type": "object", "properties": { "arrowsColor": { "type": "string" }, "itemShadowBlur": { "type": "number" }, "itemShadowDirection": { "type": "number" }, "itemShadowOpacityAndColor": { "type": "string" }, "itemShadowSize": { "type": "number" }, "itemEnableShadow": { "type": "boolean" }, "itemBorderRadius": { "type": "number" }, "itemBorderWidth": { "type": "number" }, "itemBorderColor": {}, "itemResolutionMode": { "enum": ["FULL", "SCLAED_DOWN"], "type": "string" } } };
const schema12 = { "type": "object", "properties": { "groups": { "$ref": "#/definitions/Groups" }, "crop": { "$ref": "#/definitions/Crop" }, "structure": { "$ref": "#/definitions/Structure" }, "thumbnails": { "$ref": "#/definitions/Thumbnails" }, "navigationArrows": { "$ref": "#/definitions/NavigationArrows" }, "info": { "$ref": "#/definitions/Info" }, "targetItemSize": { "$ref": "#/definitions/TargetItemSize" } } };
const schema13 = { "type": "object", "properties": { "density": { "type": "number" }, "groupByOrientation": { "type": "boolean" }, "numberOfGroupsPerRow": { "type": "number" }, "allowedGroupTypes": { "type": "array", "items": { "enum": ["1", "2h", "2v", "3b", "3h", "3l", "3r", "3t", "3v"], "type": "string" } }, "repeatingGroupTypes": { "type": "array", "items": { "enum": ["1", "2h", "2v", "3b", "3h", "3l", "3r", "3t", "3v"], "type": "string" } }, "groupSize": { "type": "number" } } };
const schema14 = { "type": "object", "properties": { "method": { "enum": ["FILL", "FIT", "MAX", "MIN"], "type": "string" }, "alignment": { "enum": ["BOTTOM", "CENTER", "LEFT", "RIGHT", "TOP"], "type": "string" }, "enable": { "type": "boolean" }, "enableSmartCrop": { "type": "boolean" }, "cropOnlyFill": { "type": "boolean" }, "ratios": { "type": "array", "items": { "type": "number" } } } };
const schema18 = { "type": "object", "properties": { "enable": { "type": "boolean" }, "position": { "enum": ["ON_GALLERY", "OUTSIDE_GALLERY"], "type": "string" }, "spacing": { "type": "number" }, "marginToGallery": { "type": "number" }, "size": { "type": "number" }, "alignment": { "enum": ["BOTTOM", "LEFT", "RIGHT", "TOP"], "type": "string" } } };
const schema23 = { "type": "object", "properties": { "unit": { "enum": ["PERCENT", "PIXEL", "SMART"], "type": "string" }, "value": { "type": "number" }, "minimum": { "type": "number" } } };
const schema15 = { "type": "object", "properties": { "galleryLayout": { "type": "number" }, "galleryRatio": { "$ref": "#/definitions/GalleryRatio" }, "enableStreching": { "type": "boolean" }, "gallerySpacing": { "type": "number" }, "itemSpacing": { "type": "number" }, "scrollDirection": { "enum": ["HORIZONTAL", "VERTICAL"], "type": "string" }, "numberOfColumns": { "type": "number" }, "numberOfGridRows": { "type": "number" }, "responsiveMode": { "enum": ["FIT_TO_SCREEN", "SET_ITEMS_PER_ROW"], "type": "string" }, "columnRatios": { "type": "array", "items": { "type": "number" } }, "scatter": { "$ref": "#/definitions/Scatter" }, "layoutOrientation": { "enum": ["HORIZONTAL", "VERTICAL"], "type": "string" }, "groupsOrder": { "enum": ["BY_HEIGHT", "LEFT_TO_RIGHT"], "type": "string" } } };
const schema16 = { "type": "object", "properties": { "value": { "type": "number" }, "includeExternalInfo": { "type": "boolean" } }, "required": ["includeExternalInfo", "value"] };
const schema17 = { "type": "object", "properties": { "randomScatter": { "type": "number" }, "manualScatter": { "type": "string" } } };
function validate12(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.galleryLayout !== undefined) {
        let data0 = data.galleryLayout;
        if (!((typeof data0 == "number") && (isFinite(data0)))) {
            const err0 = { instancePath: instancePath + "/galleryLayout", schemaPath: "#/properties/galleryLayout/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema15.properties.galleryLayout.type, parentSchema: schema15.properties.galleryLayout, data: data0 };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    if (data.galleryRatio !== undefined) {
        let data1 = data.galleryRatio;
        if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
            if (data1.includeExternalInfo === undefined) {
                const err1 = { instancePath: instancePath + "/galleryRatio", schemaPath: "#/definitions/GalleryRatio/required", keyword: "required", params: { missingProperty: "includeExternalInfo" }, message: "must have required property '" + "includeExternalInfo" + "'", schema: schema16.required, parentSchema: schema16, data: data1 };
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
            if (data1.value === undefined) {
                const err2 = { instancePath: instancePath + "/galleryRatio", schemaPath: "#/definitions/GalleryRatio/required", keyword: "required", params: { missingProperty: "value" }, message: "must have required property '" + "value" + "'", schema: schema16.required, parentSchema: schema16, data: data1 };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
            if (data1.value !== undefined) {
                let data2 = data1.value;
                if (!((typeof data2 == "number") && (isFinite(data2)))) {
                    const err3 = { instancePath: instancePath + "/galleryRatio/value", schemaPath: "#/definitions/GalleryRatio/properties/value/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema16.properties.value.type, parentSchema: schema16.properties.value, data: data2 };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
            }
            if (data1.includeExternalInfo !== undefined) {
                let data3 = data1.includeExternalInfo;
                if (typeof data3 !== "boolean") {
                    const err4 = { instancePath: instancePath + "/galleryRatio/includeExternalInfo", schemaPath: "#/definitions/GalleryRatio/properties/includeExternalInfo/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema16.properties.includeExternalInfo.type, parentSchema: schema16.properties.includeExternalInfo, data: data3 };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
        }
        else {
            const err5 = { instancePath: instancePath + "/galleryRatio", schemaPath: "#/definitions/GalleryRatio/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema16.type, parentSchema: schema16, data: data1 };
            if (vErrors === null) {
                vErrors = [err5];
            }
            else {
                vErrors.push(err5);
            }
            errors++;
        }
    }
    if (data.enableStreching !== undefined) {
        let data4 = data.enableStreching;
        if (typeof data4 !== "boolean") {
            const err6 = { instancePath: instancePath + "/enableStreching", schemaPath: "#/properties/enableStreching/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema15.properties.enableStreching.type, parentSchema: schema15.properties.enableStreching, data: data4 };
            if (vErrors === null) {
                vErrors = [err6];
            }
            else {
                vErrors.push(err6);
            }
            errors++;
        }
    }
    if (data.gallerySpacing !== undefined) {
        let data5 = data.gallerySpacing;
        if (!((typeof data5 == "number") && (isFinite(data5)))) {
            const err7 = { instancePath: instancePath + "/gallerySpacing", schemaPath: "#/properties/gallerySpacing/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema15.properties.gallerySpacing.type, parentSchema: schema15.properties.gallerySpacing, data: data5 };
            if (vErrors === null) {
                vErrors = [err7];
            }
            else {
                vErrors.push(err7);
            }
            errors++;
        }
    }
    if (data.itemSpacing !== undefined) {
        let data6 = data.itemSpacing;
        if (!((typeof data6 == "number") && (isFinite(data6)))) {
            const err8 = { instancePath: instancePath + "/itemSpacing", schemaPath: "#/properties/itemSpacing/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema15.properties.itemSpacing.type, parentSchema: schema15.properties.itemSpacing, data: data6 };
            if (vErrors === null) {
                vErrors = [err8];
            }
            else {
                vErrors.push(err8);
            }
            errors++;
        }
    }
    if (data.scrollDirection !== undefined) {
        let data7 = data.scrollDirection;
        if (typeof data7 !== "string") {
            const err9 = { instancePath: instancePath + "/scrollDirection", schemaPath: "#/properties/scrollDirection/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema15.properties.scrollDirection.type, parentSchema: schema15.properties.scrollDirection, data: data7 };
            if (vErrors === null) {
                vErrors = [err9];
            }
            else {
                vErrors.push(err9);
            }
            errors++;
        }
        if (!((data7 === "HORIZONTAL") || (data7 === "VERTICAL"))) {
            const err10 = { instancePath: instancePath + "/scrollDirection", schemaPath: "#/properties/scrollDirection/enum", keyword: "enum", params: { allowedValues: schema15.properties.scrollDirection.enum }, message: "must be equal to one of the allowed values", schema: schema15.properties.scrollDirection.enum, parentSchema: schema15.properties.scrollDirection, data: data7 };
            if (vErrors === null) {
                vErrors = [err10];
            }
            else {
                vErrors.push(err10);
            }
            errors++;
        }
    }
    if (data.numberOfColumns !== undefined) {
        let data8 = data.numberOfColumns;
        if (!((typeof data8 == "number") && (isFinite(data8)))) {
            const err11 = { instancePath: instancePath + "/numberOfColumns", schemaPath: "#/properties/numberOfColumns/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema15.properties.numberOfColumns.type, parentSchema: schema15.properties.numberOfColumns, data: data8 };
            if (vErrors === null) {
                vErrors = [err11];
            }
            else {
                vErrors.push(err11);
            }
            errors++;
        }
    }
    if (data.numberOfGridRows !== undefined) {
        let data9 = data.numberOfGridRows;
        if (!((typeof data9 == "number") && (isFinite(data9)))) {
            const err12 = { instancePath: instancePath + "/numberOfGridRows", schemaPath: "#/properties/numberOfGridRows/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema15.properties.numberOfGridRows.type, parentSchema: schema15.properties.numberOfGridRows, data: data9 };
            if (vErrors === null) {
                vErrors = [err12];
            }
            else {
                vErrors.push(err12);
            }
            errors++;
        }
    }
    if (data.responsiveMode !== undefined) {
        let data10 = data.responsiveMode;
        if (typeof data10 !== "string") {
            const err13 = { instancePath: instancePath + "/responsiveMode", schemaPath: "#/properties/responsiveMode/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema15.properties.responsiveMode.type, parentSchema: schema15.properties.responsiveMode, data: data10 };
            if (vErrors === null) {
                vErrors = [err13];
            }
            else {
                vErrors.push(err13);
            }
            errors++;
        }
        if (!((data10 === "FIT_TO_SCREEN") || (data10 === "SET_ITEMS_PER_ROW"))) {
            const err14 = { instancePath: instancePath + "/responsiveMode", schemaPath: "#/properties/responsiveMode/enum", keyword: "enum", params: { allowedValues: schema15.properties.responsiveMode.enum }, message: "must be equal to one of the allowed values", schema: schema15.properties.responsiveMode.enum, parentSchema: schema15.properties.responsiveMode, data: data10 };
            if (vErrors === null) {
                vErrors = [err14];
            }
            else {
                vErrors.push(err14);
            }
            errors++;
        }
    }
    if (data.columnRatios !== undefined) {
        let data11 = data.columnRatios;
        if (Array.isArray(data11)) {
            const len0 = data11.length;
            for (let i0 = 0; i0 < len0; i0++) {
                let data12 = data11[i0];
                if (!((typeof data12 == "number") && (isFinite(data12)))) {
                    const err15 = { instancePath: instancePath + "/columnRatios/" + i0, schemaPath: "#/properties/columnRatios/items/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema15.properties.columnRatios.items.type, parentSchema: schema15.properties.columnRatios.items, data: data12 };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
        }
        else {
            const err16 = { instancePath: instancePath + "/columnRatios", schemaPath: "#/properties/columnRatios/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema15.properties.columnRatios.type, parentSchema: schema15.properties.columnRatios, data: data11 };
            if (vErrors === null) {
                vErrors = [err16];
            }
            else {
                vErrors.push(err16);
            }
            errors++;
        }
    }
    if (data.scatter !== undefined) {
        let data13 = data.scatter;
        if (data13 && typeof data13 == "object" && !Array.isArray(data13)) {
            if (data13.randomScatter !== undefined) {
                let data14 = data13.randomScatter;
                if (!((typeof data14 == "number") && (isFinite(data14)))) {
                    const err17 = { instancePath: instancePath + "/scatter/randomScatter", schemaPath: "#/definitions/Scatter/properties/randomScatter/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema17.properties.randomScatter.type, parentSchema: schema17.properties.randomScatter, data: data14 };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
            }
            if (data13.manualScatter !== undefined) {
                let data15 = data13.manualScatter;
                if (typeof data15 !== "string") {
                    const err18 = { instancePath: instancePath + "/scatter/manualScatter", schemaPath: "#/definitions/Scatter/properties/manualScatter/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema17.properties.manualScatter.type, parentSchema: schema17.properties.manualScatter, data: data15 };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
            }
        }
        else {
            const err19 = { instancePath: instancePath + "/scatter", schemaPath: "#/definitions/Scatter/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema17.type, parentSchema: schema17, data: data13 };
            if (vErrors === null) {
                vErrors = [err19];
            }
            else {
                vErrors.push(err19);
            }
            errors++;
        }
    }
    if (data.layoutOrientation !== undefined) {
        let data16 = data.layoutOrientation;
        if (typeof data16 !== "string") {
            const err20 = { instancePath: instancePath + "/layoutOrientation", schemaPath: "#/properties/layoutOrientation/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema15.properties.layoutOrientation.type, parentSchema: schema15.properties.layoutOrientation, data: data16 };
            if (vErrors === null) {
                vErrors = [err20];
            }
            else {
                vErrors.push(err20);
            }
            errors++;
        }
        if (!((data16 === "HORIZONTAL") || (data16 === "VERTICAL"))) {
            const err21 = { instancePath: instancePath + "/layoutOrientation", schemaPath: "#/properties/layoutOrientation/enum", keyword: "enum", params: { allowedValues: schema15.properties.layoutOrientation.enum }, message: "must be equal to one of the allowed values", schema: schema15.properties.layoutOrientation.enum, parentSchema: schema15.properties.layoutOrientation, data: data16 };
            if (vErrors === null) {
                vErrors = [err21];
            }
            else {
                vErrors.push(err21);
            }
            errors++;
        }
    }
    if (data.groupsOrder !== undefined) {
        let data17 = data.groupsOrder;
        if (typeof data17 !== "string") {
            const err22 = { instancePath: instancePath + "/groupsOrder", schemaPath: "#/properties/groupsOrder/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema15.properties.groupsOrder.type, parentSchema: schema15.properties.groupsOrder, data: data17 };
            if (vErrors === null) {
                vErrors = [err22];
            }
            else {
                vErrors.push(err22);
            }
            errors++;
        }
        if (!((data17 === "BY_HEIGHT") || (data17 === "LEFT_TO_RIGHT"))) {
            const err23 = { instancePath: instancePath + "/groupsOrder", schemaPath: "#/properties/groupsOrder/enum", keyword: "enum", params: { allowedValues: schema15.properties.groupsOrder.enum }, message: "must be equal to one of the allowed values", schema: schema15.properties.groupsOrder.enum, parentSchema: schema15.properties.groupsOrder, data: data17 };
            if (vErrors === null) {
                vErrors = [err23];
            }
            else {
                vErrors.push(err23);
            }
            errors++;
        }
    }
}
else {
    const err24 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema15.type, parentSchema: schema15, data };
    if (vErrors === null) {
        vErrors = [err24];
    }
    else {
        vErrors.push(err24);
    }
    errors++;
} validate12.errors = vErrors; return errors === 0; }
const schema19 = { "type": "object", "properties": { "enable": { "type": "boolean" }, "size": { "type": "number" }, "padding": { "type": "number" }, "position": { "enum": ["MOUSE_CURSOR", "ON_GALLERY", "OUTSIDE_GALLERY"], "type": "string" }, "verticalAlignment": { "enum": ["IMAGE_CENTER", "INFO_CENTER", "ITEM_CENTER"], "type": "string" }, "type": { "enum": ["ARROW_2", "ARROW_3", "DEFAULT_ARROW"], "type": "string" }, "container": { "$ref": "#/definitions/NavigationArrowsContainer" }, "mouseCursorContainerMaxWidth": { "type": "number" } } };
const schema20 = { "type": "object", "properties": { "type": { "enum": ["BOX", "NONE", "SHADOW"], "type": "string" }, "borderRadius": { "type": "number" }, "backgroundColor": { "type": "string" } } };
function validate14(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.enable !== undefined) {
        let data0 = data.enable;
        if (typeof data0 !== "boolean") {
            const err0 = { instancePath: instancePath + "/enable", schemaPath: "#/properties/enable/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema19.properties.enable.type, parentSchema: schema19.properties.enable, data: data0 };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    if (data.size !== undefined) {
        let data1 = data.size;
        if (!((typeof data1 == "number") && (isFinite(data1)))) {
            const err1 = { instancePath: instancePath + "/size", schemaPath: "#/properties/size/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema19.properties.size.type, parentSchema: schema19.properties.size, data: data1 };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
    }
    if (data.padding !== undefined) {
        let data2 = data.padding;
        if (!((typeof data2 == "number") && (isFinite(data2)))) {
            const err2 = { instancePath: instancePath + "/padding", schemaPath: "#/properties/padding/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema19.properties.padding.type, parentSchema: schema19.properties.padding, data: data2 };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.position !== undefined) {
        let data3 = data.position;
        if (typeof data3 !== "string") {
            const err3 = { instancePath: instancePath + "/position", schemaPath: "#/properties/position/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema19.properties.position.type, parentSchema: schema19.properties.position, data: data3 };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
        }
        if (!(((data3 === "MOUSE_CURSOR") || (data3 === "ON_GALLERY")) || (data3 === "OUTSIDE_GALLERY"))) {
            const err4 = { instancePath: instancePath + "/position", schemaPath: "#/properties/position/enum", keyword: "enum", params: { allowedValues: schema19.properties.position.enum }, message: "must be equal to one of the allowed values", schema: schema19.properties.position.enum, parentSchema: schema19.properties.position, data: data3 };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    if (data.verticalAlignment !== undefined) {
        let data4 = data.verticalAlignment;
        if (typeof data4 !== "string") {
            const err5 = { instancePath: instancePath + "/verticalAlignment", schemaPath: "#/properties/verticalAlignment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema19.properties.verticalAlignment.type, parentSchema: schema19.properties.verticalAlignment, data: data4 };
            if (vErrors === null) {
                vErrors = [err5];
            }
            else {
                vErrors.push(err5);
            }
            errors++;
        }
        if (!(((data4 === "IMAGE_CENTER") || (data4 === "INFO_CENTER")) || (data4 === "ITEM_CENTER"))) {
            const err6 = { instancePath: instancePath + "/verticalAlignment", schemaPath: "#/properties/verticalAlignment/enum", keyword: "enum", params: { allowedValues: schema19.properties.verticalAlignment.enum }, message: "must be equal to one of the allowed values", schema: schema19.properties.verticalAlignment.enum, parentSchema: schema19.properties.verticalAlignment, data: data4 };
            if (vErrors === null) {
                vErrors = [err6];
            }
            else {
                vErrors.push(err6);
            }
            errors++;
        }
    }
    if (data.type !== undefined) {
        let data5 = data.type;
        if (typeof data5 !== "string") {
            const err7 = { instancePath: instancePath + "/type", schemaPath: "#/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema19.properties.type.type, parentSchema: schema19.properties.type, data: data5 };
            if (vErrors === null) {
                vErrors = [err7];
            }
            else {
                vErrors.push(err7);
            }
            errors++;
        }
        if (!(((data5 === "ARROW_2") || (data5 === "ARROW_3")) || (data5 === "DEFAULT_ARROW"))) {
            const err8 = { instancePath: instancePath + "/type", schemaPath: "#/properties/type/enum", keyword: "enum", params: { allowedValues: schema19.properties.type.enum }, message: "must be equal to one of the allowed values", schema: schema19.properties.type.enum, parentSchema: schema19.properties.type, data: data5 };
            if (vErrors === null) {
                vErrors = [err8];
            }
            else {
                vErrors.push(err8);
            }
            errors++;
        }
    }
    if (data.container !== undefined) {
        let data6 = data.container;
        if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
            if (data6.type !== undefined) {
                let data7 = data6.type;
                if (typeof data7 !== "string") {
                    const err9 = { instancePath: instancePath + "/container/type", schemaPath: "#/definitions/NavigationArrowsContainer/properties/type/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema20.properties.type.type, parentSchema: schema20.properties.type, data: data7 };
                    if (vErrors === null) {
                        vErrors = [err9];
                    }
                    else {
                        vErrors.push(err9);
                    }
                    errors++;
                }
                if (!(((data7 === "BOX") || (data7 === "NONE")) || (data7 === "SHADOW"))) {
                    const err10 = { instancePath: instancePath + "/container/type", schemaPath: "#/definitions/NavigationArrowsContainer/properties/type/enum", keyword: "enum", params: { allowedValues: schema20.properties.type.enum }, message: "must be equal to one of the allowed values", schema: schema20.properties.type.enum, parentSchema: schema20.properties.type, data: data7 };
                    if (vErrors === null) {
                        vErrors = [err10];
                    }
                    else {
                        vErrors.push(err10);
                    }
                    errors++;
                }
            }
            if (data6.borderRadius !== undefined) {
                let data8 = data6.borderRadius;
                if (!((typeof data8 == "number") && (isFinite(data8)))) {
                    const err11 = { instancePath: instancePath + "/container/borderRadius", schemaPath: "#/definitions/NavigationArrowsContainer/properties/borderRadius/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema20.properties.borderRadius.type, parentSchema: schema20.properties.borderRadius, data: data8 };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
            }
            if (data6.backgroundColor !== undefined) {
                let data9 = data6.backgroundColor;
                if (typeof data9 !== "string") {
                    const err12 = { instancePath: instancePath + "/container/backgroundColor", schemaPath: "#/definitions/NavigationArrowsContainer/properties/backgroundColor/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema20.properties.backgroundColor.type, parentSchema: schema20.properties.backgroundColor, data: data9 };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
            }
        }
        else {
            const err13 = { instancePath: instancePath + "/container", schemaPath: "#/definitions/NavigationArrowsContainer/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema20.type, parentSchema: schema20, data: data6 };
            if (vErrors === null) {
                vErrors = [err13];
            }
            else {
                vErrors.push(err13);
            }
            errors++;
        }
    }
    if (data.mouseCursorContainerMaxWidth !== undefined) {
        let data10 = data.mouseCursorContainerMaxWidth;
        if (!((typeof data10 == "number") && (isFinite(data10)))) {
            const err14 = { instancePath: instancePath + "/mouseCursorContainerMaxWidth", schemaPath: "#/properties/mouseCursorContainerMaxWidth/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema19.properties.mouseCursorContainerMaxWidth.type, parentSchema: schema19.properties.mouseCursorContainerMaxWidth, data: data10 };
            if (vErrors === null) {
                vErrors = [err14];
            }
            else {
                vErrors.push(err14);
            }
            errors++;
        }
    }
}
else {
    const err15 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema19.type, parentSchema: schema19, data };
    if (vErrors === null) {
        vErrors = [err15];
    }
    else {
        vErrors.push(err15);
    }
    errors++;
} validate14.errors = vErrors; return errors === 0; }
const schema21 = { "type": "object", "properties": { "sizeUnits": { "enum": ["PERCENT", "PIXEL"], "type": "string" }, "width": { "type": "number" }, "height": { "type": "number" }, "spacing": { "type": "number" }, "layout": { "enum": ["ATTACHED_BACKGROUND", "DONT_SHOW", "NO_BACKGROUND", "SEPARATED_BACKGROUND"], "type": "string" }, "border": { "$ref": "#/definitions/InfoBorder" }, "placement": { "enum": ["ABOVE", "ALTERNATE_HORIZONTALLY", "ALTERNATE_VERTICALLY", "BELOW", "LEFT", "OVERLAY", "RIGHT"], "type": "string" } } };
const schema22 = { "type": "object", "properties": { "width": { "type": "number" }, "color": { "type": "string" }, "radius": { "type": "number" } } };
function validate16(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.sizeUnits !== undefined) {
        let data0 = data.sizeUnits;
        if (typeof data0 !== "string") {
            const err0 = { instancePath: instancePath + "/sizeUnits", schemaPath: "#/properties/sizeUnits/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema21.properties.sizeUnits.type, parentSchema: schema21.properties.sizeUnits, data: data0 };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (!((data0 === "PERCENT") || (data0 === "PIXEL"))) {
            const err1 = { instancePath: instancePath + "/sizeUnits", schemaPath: "#/properties/sizeUnits/enum", keyword: "enum", params: { allowedValues: schema21.properties.sizeUnits.enum }, message: "must be equal to one of the allowed values", schema: schema21.properties.sizeUnits.enum, parentSchema: schema21.properties.sizeUnits, data: data0 };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
    }
    if (data.width !== undefined) {
        let data1 = data.width;
        if (!((typeof data1 == "number") && (isFinite(data1)))) {
            const err2 = { instancePath: instancePath + "/width", schemaPath: "#/properties/width/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema21.properties.width.type, parentSchema: schema21.properties.width, data: data1 };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.height !== undefined) {
        let data2 = data.height;
        if (!((typeof data2 == "number") && (isFinite(data2)))) {
            const err3 = { instancePath: instancePath + "/height", schemaPath: "#/properties/height/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema21.properties.height.type, parentSchema: schema21.properties.height, data: data2 };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
        }
    }
    if (data.spacing !== undefined) {
        let data3 = data.spacing;
        if (!((typeof data3 == "number") && (isFinite(data3)))) {
            const err4 = { instancePath: instancePath + "/spacing", schemaPath: "#/properties/spacing/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema21.properties.spacing.type, parentSchema: schema21.properties.spacing, data: data3 };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    if (data.layout !== undefined) {
        let data4 = data.layout;
        if (typeof data4 !== "string") {
            const err5 = { instancePath: instancePath + "/layout", schemaPath: "#/properties/layout/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema21.properties.layout.type, parentSchema: schema21.properties.layout, data: data4 };
            if (vErrors === null) {
                vErrors = [err5];
            }
            else {
                vErrors.push(err5);
            }
            errors++;
        }
        if (!((((data4 === "ATTACHED_BACKGROUND") || (data4 === "DONT_SHOW")) || (data4 === "NO_BACKGROUND")) || (data4 === "SEPARATED_BACKGROUND"))) {
            const err6 = { instancePath: instancePath + "/layout", schemaPath: "#/properties/layout/enum", keyword: "enum", params: { allowedValues: schema21.properties.layout.enum }, message: "must be equal to one of the allowed values", schema: schema21.properties.layout.enum, parentSchema: schema21.properties.layout, data: data4 };
            if (vErrors === null) {
                vErrors = [err6];
            }
            else {
                vErrors.push(err6);
            }
            errors++;
        }
    }
    if (data.border !== undefined) {
        let data5 = data.border;
        if (data5 && typeof data5 == "object" && !Array.isArray(data5)) {
            if (data5.width !== undefined) {
                let data6 = data5.width;
                if (!((typeof data6 == "number") && (isFinite(data6)))) {
                    const err7 = { instancePath: instancePath + "/border/width", schemaPath: "#/definitions/InfoBorder/properties/width/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema22.properties.width.type, parentSchema: schema22.properties.width, data: data6 };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                }
            }
            if (data5.color !== undefined) {
                let data7 = data5.color;
                if (typeof data7 !== "string") {
                    const err8 = { instancePath: instancePath + "/border/color", schemaPath: "#/definitions/InfoBorder/properties/color/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.color.type, parentSchema: schema22.properties.color, data: data7 };
                    if (vErrors === null) {
                        vErrors = [err8];
                    }
                    else {
                        vErrors.push(err8);
                    }
                    errors++;
                }
            }
            if (data5.radius !== undefined) {
                let data8 = data5.radius;
                if (!((typeof data8 == "number") && (isFinite(data8)))) {
                    const err9 = { instancePath: instancePath + "/border/radius", schemaPath: "#/definitions/InfoBorder/properties/radius/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema22.properties.radius.type, parentSchema: schema22.properties.radius, data: data8 };
                    if (vErrors === null) {
                        vErrors = [err9];
                    }
                    else {
                        vErrors.push(err9);
                    }
                    errors++;
                }
            }
        }
        else {
            const err10 = { instancePath: instancePath + "/border", schemaPath: "#/definitions/InfoBorder/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema22.type, parentSchema: schema22, data: data5 };
            if (vErrors === null) {
                vErrors = [err10];
            }
            else {
                vErrors.push(err10);
            }
            errors++;
        }
    }
    if (data.placement !== undefined) {
        let data9 = data.placement;
        if (typeof data9 !== "string") {
            const err11 = { instancePath: instancePath + "/placement", schemaPath: "#/properties/placement/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema21.properties.placement.type, parentSchema: schema21.properties.placement, data: data9 };
            if (vErrors === null) {
                vErrors = [err11];
            }
            else {
                vErrors.push(err11);
            }
            errors++;
        }
        if (!(((((((data9 === "ABOVE") || (data9 === "ALTERNATE_HORIZONTALLY")) || (data9 === "ALTERNATE_VERTICALLY")) || (data9 === "BELOW")) || (data9 === "LEFT")) || (data9 === "OVERLAY")) || (data9 === "RIGHT"))) {
            const err12 = { instancePath: instancePath + "/placement", schemaPath: "#/properties/placement/enum", keyword: "enum", params: { allowedValues: schema21.properties.placement.enum }, message: "must be equal to one of the allowed values", schema: schema21.properties.placement.enum, parentSchema: schema21.properties.placement, data: data9 };
            if (vErrors === null) {
                vErrors = [err12];
            }
            else {
                vErrors.push(err12);
            }
            errors++;
        }
    }
}
else {
    const err13 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema21.type, parentSchema: schema21, data };
    if (vErrors === null) {
        vErrors = [err13];
    }
    else {
        vErrors.push(err13);
    }
    errors++;
} validate16.errors = vErrors; return errors === 0; }
function validate11(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.groups !== undefined) {
        let data0 = data.groups;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.density !== undefined) {
                let data1 = data0.density;
                if (!((typeof data1 == "number") && (isFinite(data1)))) {
                    const err0 = { instancePath: instancePath + "/groups/density", schemaPath: "#/definitions/Groups/properties/density/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema13.properties.density.type, parentSchema: schema13.properties.density, data: data1 };
                    if (vErrors === null) {
                        vErrors = [err0];
                    }
                    else {
                        vErrors.push(err0);
                    }
                    errors++;
                }
            }
            if (data0.groupByOrientation !== undefined) {
                let data2 = data0.groupByOrientation;
                if (typeof data2 !== "boolean") {
                    const err1 = { instancePath: instancePath + "/groups/groupByOrientation", schemaPath: "#/definitions/Groups/properties/groupByOrientation/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema13.properties.groupByOrientation.type, parentSchema: schema13.properties.groupByOrientation, data: data2 };
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
            if (data0.numberOfGroupsPerRow !== undefined) {
                let data3 = data0.numberOfGroupsPerRow;
                if (!((typeof data3 == "number") && (isFinite(data3)))) {
                    const err2 = { instancePath: instancePath + "/groups/numberOfGroupsPerRow", schemaPath: "#/definitions/Groups/properties/numberOfGroupsPerRow/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema13.properties.numberOfGroupsPerRow.type, parentSchema: schema13.properties.numberOfGroupsPerRow, data: data3 };
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
            if (data0.allowedGroupTypes !== undefined) {
                let data4 = data0.allowedGroupTypes;
                if (Array.isArray(data4)) {
                    const len0 = data4.length;
                    for (let i0 = 0; i0 < len0; i0++) {
                        let data5 = data4[i0];
                        if (typeof data5 !== "string") {
                            const err3 = { instancePath: instancePath + "/groups/allowedGroupTypes/" + i0, schemaPath: "#/definitions/Groups/properties/allowedGroupTypes/items/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema13.properties.allowedGroupTypes.items.type, parentSchema: schema13.properties.allowedGroupTypes.items, data: data5 };
                            if (vErrors === null) {
                                vErrors = [err3];
                            }
                            else {
                                vErrors.push(err3);
                            }
                            errors++;
                        }
                        if (!(((((((((data5 === "1") || (data5 === "2h")) || (data5 === "2v")) || (data5 === "3b")) || (data5 === "3h")) || (data5 === "3l")) || (data5 === "3r")) || (data5 === "3t")) || (data5 === "3v"))) {
                            const err4 = { instancePath: instancePath + "/groups/allowedGroupTypes/" + i0, schemaPath: "#/definitions/Groups/properties/allowedGroupTypes/items/enum", keyword: "enum", params: { allowedValues: schema13.properties.allowedGroupTypes.items.enum }, message: "must be equal to one of the allowed values", schema: schema13.properties.allowedGroupTypes.items.enum, parentSchema: schema13.properties.allowedGroupTypes.items, data: data5 };
                            if (vErrors === null) {
                                vErrors = [err4];
                            }
                            else {
                                vErrors.push(err4);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err5 = { instancePath: instancePath + "/groups/allowedGroupTypes", schemaPath: "#/definitions/Groups/properties/allowedGroupTypes/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema13.properties.allowedGroupTypes.type, parentSchema: schema13.properties.allowedGroupTypes, data: data4 };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
            }
            if (data0.repeatingGroupTypes !== undefined) {
                let data6 = data0.repeatingGroupTypes;
                if (Array.isArray(data6)) {
                    const len1 = data6.length;
                    for (let i1 = 0; i1 < len1; i1++) {
                        let data7 = data6[i1];
                        if (typeof data7 !== "string") {
                            const err6 = { instancePath: instancePath + "/groups/repeatingGroupTypes/" + i1, schemaPath: "#/definitions/Groups/properties/repeatingGroupTypes/items/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema13.properties.repeatingGroupTypes.items.type, parentSchema: schema13.properties.repeatingGroupTypes.items, data: data7 };
                            if (vErrors === null) {
                                vErrors = [err6];
                            }
                            else {
                                vErrors.push(err6);
                            }
                            errors++;
                        }
                        if (!(((((((((data7 === "1") || (data7 === "2h")) || (data7 === "2v")) || (data7 === "3b")) || (data7 === "3h")) || (data7 === "3l")) || (data7 === "3r")) || (data7 === "3t")) || (data7 === "3v"))) {
                            const err7 = { instancePath: instancePath + "/groups/repeatingGroupTypes/" + i1, schemaPath: "#/definitions/Groups/properties/repeatingGroupTypes/items/enum", keyword: "enum", params: { allowedValues: schema13.properties.repeatingGroupTypes.items.enum }, message: "must be equal to one of the allowed values", schema: schema13.properties.repeatingGroupTypes.items.enum, parentSchema: schema13.properties.repeatingGroupTypes.items, data: data7 };
                            if (vErrors === null) {
                                vErrors = [err7];
                            }
                            else {
                                vErrors.push(err7);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err8 = { instancePath: instancePath + "/groups/repeatingGroupTypes", schemaPath: "#/definitions/Groups/properties/repeatingGroupTypes/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema13.properties.repeatingGroupTypes.type, parentSchema: schema13.properties.repeatingGroupTypes, data: data6 };
                    if (vErrors === null) {
                        vErrors = [err8];
                    }
                    else {
                        vErrors.push(err8);
                    }
                    errors++;
                }
            }
            if (data0.groupSize !== undefined) {
                let data8 = data0.groupSize;
                if (!((typeof data8 == "number") && (isFinite(data8)))) {
                    const err9 = { instancePath: instancePath + "/groups/groupSize", schemaPath: "#/definitions/Groups/properties/groupSize/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema13.properties.groupSize.type, parentSchema: schema13.properties.groupSize, data: data8 };
                    if (vErrors === null) {
                        vErrors = [err9];
                    }
                    else {
                        vErrors.push(err9);
                    }
                    errors++;
                }
            }
        }
        else {
            const err10 = { instancePath: instancePath + "/groups", schemaPath: "#/definitions/Groups/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema13.type, parentSchema: schema13, data: data0 };
            if (vErrors === null) {
                vErrors = [err10];
            }
            else {
                vErrors.push(err10);
            }
            errors++;
        }
    }
    if (data.crop !== undefined) {
        let data9 = data.crop;
        if (data9 && typeof data9 == "object" && !Array.isArray(data9)) {
            if (data9.method !== undefined) {
                let data10 = data9.method;
                if (typeof data10 !== "string") {
                    const err11 = { instancePath: instancePath + "/crop/method", schemaPath: "#/definitions/Crop/properties/method/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema14.properties.method.type, parentSchema: schema14.properties.method, data: data10 };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
                if (!((((data10 === "FILL") || (data10 === "FIT")) || (data10 === "MAX")) || (data10 === "MIN"))) {
                    const err12 = { instancePath: instancePath + "/crop/method", schemaPath: "#/definitions/Crop/properties/method/enum", keyword: "enum", params: { allowedValues: schema14.properties.method.enum }, message: "must be equal to one of the allowed values", schema: schema14.properties.method.enum, parentSchema: schema14.properties.method, data: data10 };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
            }
            if (data9.alignment !== undefined) {
                let data11 = data9.alignment;
                if (typeof data11 !== "string") {
                    const err13 = { instancePath: instancePath + "/crop/alignment", schemaPath: "#/definitions/Crop/properties/alignment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema14.properties.alignment.type, parentSchema: schema14.properties.alignment, data: data11 };
                    if (vErrors === null) {
                        vErrors = [err13];
                    }
                    else {
                        vErrors.push(err13);
                    }
                    errors++;
                }
                if (!(((((data11 === "BOTTOM") || (data11 === "CENTER")) || (data11 === "LEFT")) || (data11 === "RIGHT")) || (data11 === "TOP"))) {
                    const err14 = { instancePath: instancePath + "/crop/alignment", schemaPath: "#/definitions/Crop/properties/alignment/enum", keyword: "enum", params: { allowedValues: schema14.properties.alignment.enum }, message: "must be equal to one of the allowed values", schema: schema14.properties.alignment.enum, parentSchema: schema14.properties.alignment, data: data11 };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
            }
            if (data9.enable !== undefined) {
                let data12 = data9.enable;
                if (typeof data12 !== "boolean") {
                    const err15 = { instancePath: instancePath + "/crop/enable", schemaPath: "#/definitions/Crop/properties/enable/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema14.properties.enable.type, parentSchema: schema14.properties.enable, data: data12 };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            if (data9.enableSmartCrop !== undefined) {
                let data13 = data9.enableSmartCrop;
                if (typeof data13 !== "boolean") {
                    const err16 = { instancePath: instancePath + "/crop/enableSmartCrop", schemaPath: "#/definitions/Crop/properties/enableSmartCrop/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema14.properties.enableSmartCrop.type, parentSchema: schema14.properties.enableSmartCrop, data: data13 };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
            }
            if (data9.cropOnlyFill !== undefined) {
                let data14 = data9.cropOnlyFill;
                if (typeof data14 !== "boolean") {
                    const err17 = { instancePath: instancePath + "/crop/cropOnlyFill", schemaPath: "#/definitions/Crop/properties/cropOnlyFill/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema14.properties.cropOnlyFill.type, parentSchema: schema14.properties.cropOnlyFill, data: data14 };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
            }
            if (data9.ratios !== undefined) {
                let data15 = data9.ratios;
                if (Array.isArray(data15)) {
                    const len2 = data15.length;
                    for (let i2 = 0; i2 < len2; i2++) {
                        let data16 = data15[i2];
                        if (!((typeof data16 == "number") && (isFinite(data16)))) {
                            const err18 = { instancePath: instancePath + "/crop/ratios/" + i2, schemaPath: "#/definitions/Crop/properties/ratios/items/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema14.properties.ratios.items.type, parentSchema: schema14.properties.ratios.items, data: data16 };
                            if (vErrors === null) {
                                vErrors = [err18];
                            }
                            else {
                                vErrors.push(err18);
                            }
                            errors++;
                        }
                    }
                }
                else {
                    const err19 = { instancePath: instancePath + "/crop/ratios", schemaPath: "#/definitions/Crop/properties/ratios/type", keyword: "type", params: { type: "array" }, message: "must be array", schema: schema14.properties.ratios.type, parentSchema: schema14.properties.ratios, data: data15 };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
            }
        }
        else {
            const err20 = { instancePath: instancePath + "/crop", schemaPath: "#/definitions/Crop/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema14.type, parentSchema: schema14, data: data9 };
            if (vErrors === null) {
                vErrors = [err20];
            }
            else {
                vErrors.push(err20);
            }
            errors++;
        }
    }
    if (data.structure !== undefined) {
        if (!(validate12(data.structure, { instancePath: instancePath + "/structure", parentData: data, parentDataProperty: "structure", rootData }))) {
            vErrors = vErrors === null ? validate12.errors : vErrors.concat(validate12.errors);
            errors = vErrors.length;
        }
    }
    if (data.thumbnails !== undefined) {
        let data18 = data.thumbnails;
        if (data18 && typeof data18 == "object" && !Array.isArray(data18)) {
            if (data18.enable !== undefined) {
                let data19 = data18.enable;
                if (typeof data19 !== "boolean") {
                    const err21 = { instancePath: instancePath + "/thumbnails/enable", schemaPath: "#/definitions/Thumbnails/properties/enable/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema18.properties.enable.type, parentSchema: schema18.properties.enable, data: data19 };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
            }
            if (data18.position !== undefined) {
                let data20 = data18.position;
                if (typeof data20 !== "string") {
                    const err22 = { instancePath: instancePath + "/thumbnails/position", schemaPath: "#/definitions/Thumbnails/properties/position/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema18.properties.position.type, parentSchema: schema18.properties.position, data: data20 };
                    if (vErrors === null) {
                        vErrors = [err22];
                    }
                    else {
                        vErrors.push(err22);
                    }
                    errors++;
                }
                if (!((data20 === "ON_GALLERY") || (data20 === "OUTSIDE_GALLERY"))) {
                    const err23 = { instancePath: instancePath + "/thumbnails/position", schemaPath: "#/definitions/Thumbnails/properties/position/enum", keyword: "enum", params: { allowedValues: schema18.properties.position.enum }, message: "must be equal to one of the allowed values", schema: schema18.properties.position.enum, parentSchema: schema18.properties.position, data: data20 };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
            }
            if (data18.spacing !== undefined) {
                let data21 = data18.spacing;
                if (!((typeof data21 == "number") && (isFinite(data21)))) {
                    const err24 = { instancePath: instancePath + "/thumbnails/spacing", schemaPath: "#/definitions/Thumbnails/properties/spacing/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema18.properties.spacing.type, parentSchema: schema18.properties.spacing, data: data21 };
                    if (vErrors === null) {
                        vErrors = [err24];
                    }
                    else {
                        vErrors.push(err24);
                    }
                    errors++;
                }
            }
            if (data18.marginToGallery !== undefined) {
                let data22 = data18.marginToGallery;
                if (!((typeof data22 == "number") && (isFinite(data22)))) {
                    const err25 = { instancePath: instancePath + "/thumbnails/marginToGallery", schemaPath: "#/definitions/Thumbnails/properties/marginToGallery/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema18.properties.marginToGallery.type, parentSchema: schema18.properties.marginToGallery, data: data22 };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
            }
            if (data18.size !== undefined) {
                let data23 = data18.size;
                if (!((typeof data23 == "number") && (isFinite(data23)))) {
                    const err26 = { instancePath: instancePath + "/thumbnails/size", schemaPath: "#/definitions/Thumbnails/properties/size/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema18.properties.size.type, parentSchema: schema18.properties.size, data: data23 };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            if (data18.alignment !== undefined) {
                let data24 = data18.alignment;
                if (typeof data24 !== "string") {
                    const err27 = { instancePath: instancePath + "/thumbnails/alignment", schemaPath: "#/definitions/Thumbnails/properties/alignment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema18.properties.alignment.type, parentSchema: schema18.properties.alignment, data: data24 };
                    if (vErrors === null) {
                        vErrors = [err27];
                    }
                    else {
                        vErrors.push(err27);
                    }
                    errors++;
                }
                if (!((((data24 === "BOTTOM") || (data24 === "LEFT")) || (data24 === "RIGHT")) || (data24 === "TOP"))) {
                    const err28 = { instancePath: instancePath + "/thumbnails/alignment", schemaPath: "#/definitions/Thumbnails/properties/alignment/enum", keyword: "enum", params: { allowedValues: schema18.properties.alignment.enum }, message: "must be equal to one of the allowed values", schema: schema18.properties.alignment.enum, parentSchema: schema18.properties.alignment, data: data24 };
                    if (vErrors === null) {
                        vErrors = [err28];
                    }
                    else {
                        vErrors.push(err28);
                    }
                    errors++;
                }
            }
        }
        else {
            const err29 = { instancePath: instancePath + "/thumbnails", schemaPath: "#/definitions/Thumbnails/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema18.type, parentSchema: schema18, data: data18 };
            if (vErrors === null) {
                vErrors = [err29];
            }
            else {
                vErrors.push(err29);
            }
            errors++;
        }
    }
    if (data.navigationArrows !== undefined) {
        if (!(validate14(data.navigationArrows, { instancePath: instancePath + "/navigationArrows", parentData: data, parentDataProperty: "navigationArrows", rootData }))) {
            vErrors = vErrors === null ? validate14.errors : vErrors.concat(validate14.errors);
            errors = vErrors.length;
        }
    }
    if (data.info !== undefined) {
        if (!(validate16(data.info, { instancePath: instancePath + "/info", parentData: data, parentDataProperty: "info", rootData }))) {
            vErrors = vErrors === null ? validate16.errors : vErrors.concat(validate16.errors);
            errors = vErrors.length;
        }
    }
    if (data.targetItemSize !== undefined) {
        let data27 = data.targetItemSize;
        if (data27 && typeof data27 == "object" && !Array.isArray(data27)) {
            if (data27.unit !== undefined) {
                let data28 = data27.unit;
                if (typeof data28 !== "string") {
                    const err30 = { instancePath: instancePath + "/targetItemSize/unit", schemaPath: "#/definitions/TargetItemSize/properties/unit/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema23.properties.unit.type, parentSchema: schema23.properties.unit, data: data28 };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
                if (!(((data28 === "PERCENT") || (data28 === "PIXEL")) || (data28 === "SMART"))) {
                    const err31 = { instancePath: instancePath + "/targetItemSize/unit", schemaPath: "#/definitions/TargetItemSize/properties/unit/enum", keyword: "enum", params: { allowedValues: schema23.properties.unit.enum }, message: "must be equal to one of the allowed values", schema: schema23.properties.unit.enum, parentSchema: schema23.properties.unit, data: data28 };
                    if (vErrors === null) {
                        vErrors = [err31];
                    }
                    else {
                        vErrors.push(err31);
                    }
                    errors++;
                }
            }
            if (data27.value !== undefined) {
                let data29 = data27.value;
                if (!((typeof data29 == "number") && (isFinite(data29)))) {
                    const err32 = { instancePath: instancePath + "/targetItemSize/value", schemaPath: "#/definitions/TargetItemSize/properties/value/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema23.properties.value.type, parentSchema: schema23.properties.value, data: data29 };
                    if (vErrors === null) {
                        vErrors = [err32];
                    }
                    else {
                        vErrors.push(err32);
                    }
                    errors++;
                }
            }
            if (data27.minimum !== undefined) {
                let data30 = data27.minimum;
                if (!((typeof data30 == "number") && (isFinite(data30)))) {
                    const err33 = { instancePath: instancePath + "/targetItemSize/minimum", schemaPath: "#/definitions/TargetItemSize/properties/minimum/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema23.properties.minimum.type, parentSchema: schema23.properties.minimum, data: data30 };
                    if (vErrors === null) {
                        vErrors = [err33];
                    }
                    else {
                        vErrors.push(err33);
                    }
                    errors++;
                }
            }
        }
        else {
            const err34 = { instancePath: instancePath + "/targetItemSize", schemaPath: "#/definitions/TargetItemSize/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema23.type, parentSchema: schema23, data: data27 };
            if (vErrors === null) {
                vErrors = [err34];
            }
            else {
                vErrors.push(err34);
            }
            errors++;
        }
    }
}
else {
    const err35 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema12.type, parentSchema: schema12, data };
    if (vErrors === null) {
        vErrors = [err35];
    }
    else {
        vErrors.push(err35);
    }
    errors++;
} validate11.errors = vErrors; return errors === 0; }
const schema24 = { "type": "object", "properties": { "item": { "$ref": "#/definitions/Item" }, "gallery": { "$ref": "#/definitions/Gallery" } } };
const schema25 = { "type": "object", "properties": { "clickAction": { "enum": ["ACTION", "LINK", "MAGNIFY", "NOTHING"], "type": "string" }, "video": { "$ref": "#/definitions/Video" }, "threeDimensionalScene": { "$ref": "#/definitions/ThreeDimensionalScene" }, "overlay": { "$ref": "#/definitions/Overlay" }, "content": { "$ref": "#/definitions/Content" }, "secondaryMedia": { "$ref": "#/definitions/SecondaryMedia" } } };
const schema26 = { "type": "object", "properties": { "speed": { "type": "number" }, "volume": { "type": "number" }, "loop": { "type": "boolean" }, "playTrigger": { "enum": ["AUTO", "CLICK", "HOVER"], "type": "string" }, "enablePlayButton": { "type": "boolean" }, "enableThumbnailsPlayButton": { "type": "boolean" }, "enableControls": { "type": "boolean" }, "enablePlaceholder": { "type": "boolean" } } };
const schema30 = { "type": "object", "properties": { "hoveringBehaviour": { "enum": ["ALWAYS_SHOW", "APPEARS", "DISAPPEARS", "NEVER_SHOW"], "type": "string" }, "hoverAnimation": { "enum": ["EXPAND", "FADE_IN", "NO_EFFECT", "SLIDE_DOWN", "SLIDE_LEFT", "SLIDE_RIGHT", "SLIDE_UP"], "type": "string" }, "position": { "enum": ["BUTTOM", "CENTERED_HORIZONTALLY", "CENTERED_VERTICALLY", "LEFT", "RIGHT", "TOP"], "type": "string" }, "size": { "type": "number" }, "sizeUnits": { "enum": ["PERCENT", "PIXEL"], "type": "string" }, "padding": { "type": "number" }, "backgroundColor": {} } };
const schema31 = { "type": "object", "properties": { "hoverAnimation": { "enum": ["BLUR", "COLOR_IN", "DARKENED", "GRAYSCALE", "INVERT", "NO_EFFECT", "SHRINK", "TILT", "ZOOM_IN"], "type": "string" }, "placementAnimation": { "enum": ["NO_EFFECT", "SLIDE"], "type": "string" }, "loader": { "enum": ["BLUR", "COLOR", "MAIN_COLOR"], "type": "string" }, "magnificationValue": { "type": "number" }, "tiltAngleValue": { "type": "number" } } };
const schema32 = { "type": "object", "properties": { "trigger": { "enum": ["HOVER", "OFF"], "type": "string" }, "behaviour": { "type": "string", "const": "APPEARS" } }, "required": ["behaviour", "trigger"] };
const schema27 = { "type": "object", "properties": { "transform": { "$ref": "#/definitions/Transform" }, "controls": { "$ref": "#/definitions/Controls" }, "enablePlayButton": { "type": "boolean" }, "enableThumbnailsPlayButton": { "type": "boolean" }, "playTrigger": { "enum": ["AUTO", "CLICK", "HOVER"], "type": "string" } } };
const schema28 = { "type": "object", "properties": { "rotation": { "type": "string" }, "scale": { "type": "string" }, "position": { "type": "string" } } };
const schema29 = { "type": "object", "properties": { "enableZoom": { "type": "boolean" }, "enableRotate": { "type": "boolean" }, "enablePan": { "type": "boolean" }, "enableAutoRotate": { "type": "boolean" } } };
function validate21(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.transform !== undefined) {
        let data0 = data.transform;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.rotation !== undefined) {
                let data1 = data0.rotation;
                if (typeof data1 !== "string") {
                    const err0 = { instancePath: instancePath + "/transform/rotation", schemaPath: "#/definitions/Transform/properties/rotation/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema28.properties.rotation.type, parentSchema: schema28.properties.rotation, data: data1 };
                    if (vErrors === null) {
                        vErrors = [err0];
                    }
                    else {
                        vErrors.push(err0);
                    }
                    errors++;
                }
            }
            if (data0.scale !== undefined) {
                let data2 = data0.scale;
                if (typeof data2 !== "string") {
                    const err1 = { instancePath: instancePath + "/transform/scale", schemaPath: "#/definitions/Transform/properties/scale/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema28.properties.scale.type, parentSchema: schema28.properties.scale, data: data2 };
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
            if (data0.position !== undefined) {
                let data3 = data0.position;
                if (typeof data3 !== "string") {
                    const err2 = { instancePath: instancePath + "/transform/position", schemaPath: "#/definitions/Transform/properties/position/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema28.properties.position.type, parentSchema: schema28.properties.position, data: data3 };
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
        }
        else {
            const err3 = { instancePath: instancePath + "/transform", schemaPath: "#/definitions/Transform/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema28.type, parentSchema: schema28, data: data0 };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
        }
    }
    if (data.controls !== undefined) {
        let data4 = data.controls;
        if (data4 && typeof data4 == "object" && !Array.isArray(data4)) {
            if (data4.enableZoom !== undefined) {
                let data5 = data4.enableZoom;
                if (typeof data5 !== "boolean") {
                    const err4 = { instancePath: instancePath + "/controls/enableZoom", schemaPath: "#/definitions/Controls/properties/enableZoom/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema29.properties.enableZoom.type, parentSchema: schema29.properties.enableZoom, data: data5 };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            if (data4.enableRotate !== undefined) {
                let data6 = data4.enableRotate;
                if (typeof data6 !== "boolean") {
                    const err5 = { instancePath: instancePath + "/controls/enableRotate", schemaPath: "#/definitions/Controls/properties/enableRotate/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema29.properties.enableRotate.type, parentSchema: schema29.properties.enableRotate, data: data6 };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
            }
            if (data4.enablePan !== undefined) {
                let data7 = data4.enablePan;
                if (typeof data7 !== "boolean") {
                    const err6 = { instancePath: instancePath + "/controls/enablePan", schemaPath: "#/definitions/Controls/properties/enablePan/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema29.properties.enablePan.type, parentSchema: schema29.properties.enablePan, data: data7 };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
            }
            if (data4.enableAutoRotate !== undefined) {
                let data8 = data4.enableAutoRotate;
                if (typeof data8 !== "boolean") {
                    const err7 = { instancePath: instancePath + "/controls/enableAutoRotate", schemaPath: "#/definitions/Controls/properties/enableAutoRotate/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema29.properties.enableAutoRotate.type, parentSchema: schema29.properties.enableAutoRotate, data: data8 };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                }
            }
        }
        else {
            const err8 = { instancePath: instancePath + "/controls", schemaPath: "#/definitions/Controls/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema29.type, parentSchema: schema29, data: data4 };
            if (vErrors === null) {
                vErrors = [err8];
            }
            else {
                vErrors.push(err8);
            }
            errors++;
        }
    }
    if (data.enablePlayButton !== undefined) {
        let data9 = data.enablePlayButton;
        if (typeof data9 !== "boolean") {
            const err9 = { instancePath: instancePath + "/enablePlayButton", schemaPath: "#/properties/enablePlayButton/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema27.properties.enablePlayButton.type, parentSchema: schema27.properties.enablePlayButton, data: data9 };
            if (vErrors === null) {
                vErrors = [err9];
            }
            else {
                vErrors.push(err9);
            }
            errors++;
        }
    }
    if (data.enableThumbnailsPlayButton !== undefined) {
        let data10 = data.enableThumbnailsPlayButton;
        if (typeof data10 !== "boolean") {
            const err10 = { instancePath: instancePath + "/enableThumbnailsPlayButton", schemaPath: "#/properties/enableThumbnailsPlayButton/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema27.properties.enableThumbnailsPlayButton.type, parentSchema: schema27.properties.enableThumbnailsPlayButton, data: data10 };
            if (vErrors === null) {
                vErrors = [err10];
            }
            else {
                vErrors.push(err10);
            }
            errors++;
        }
    }
    if (data.playTrigger !== undefined) {
        let data11 = data.playTrigger;
        if (typeof data11 !== "string") {
            const err11 = { instancePath: instancePath + "/playTrigger", schemaPath: "#/properties/playTrigger/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema27.properties.playTrigger.type, parentSchema: schema27.properties.playTrigger, data: data11 };
            if (vErrors === null) {
                vErrors = [err11];
            }
            else {
                vErrors.push(err11);
            }
            errors++;
        }
        if (!(((data11 === "AUTO") || (data11 === "CLICK")) || (data11 === "HOVER"))) {
            const err12 = { instancePath: instancePath + "/playTrigger", schemaPath: "#/properties/playTrigger/enum", keyword: "enum", params: { allowedValues: schema27.properties.playTrigger.enum }, message: "must be equal to one of the allowed values", schema: schema27.properties.playTrigger.enum, parentSchema: schema27.properties.playTrigger, data: data11 };
            if (vErrors === null) {
                vErrors = [err12];
            }
            else {
                vErrors.push(err12);
            }
            errors++;
        }
    }
}
else {
    const err13 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema27.type, parentSchema: schema27, data };
    if (vErrors === null) {
        vErrors = [err13];
    }
    else {
        vErrors.push(err13);
    }
    errors++;
} validate21.errors = vErrors; return errors === 0; }
function validate20(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.clickAction !== undefined) {
        let data0 = data.clickAction;
        if (typeof data0 !== "string") {
            const err0 = { instancePath: instancePath + "/clickAction", schemaPath: "#/properties/clickAction/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema25.properties.clickAction.type, parentSchema: schema25.properties.clickAction, data: data0 };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (!((((data0 === "ACTION") || (data0 === "LINK")) || (data0 === "MAGNIFY")) || (data0 === "NOTHING"))) {
            const err1 = { instancePath: instancePath + "/clickAction", schemaPath: "#/properties/clickAction/enum", keyword: "enum", params: { allowedValues: schema25.properties.clickAction.enum }, message: "must be equal to one of the allowed values", schema: schema25.properties.clickAction.enum, parentSchema: schema25.properties.clickAction, data: data0 };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
    }
    if (data.video !== undefined) {
        let data1 = data.video;
        if (data1 && typeof data1 == "object" && !Array.isArray(data1)) {
            if (data1.speed !== undefined) {
                let data2 = data1.speed;
                if (!((typeof data2 == "number") && (isFinite(data2)))) {
                    const err2 = { instancePath: instancePath + "/video/speed", schemaPath: "#/definitions/Video/properties/speed/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema26.properties.speed.type, parentSchema: schema26.properties.speed, data: data2 };
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
            if (data1.volume !== undefined) {
                let data3 = data1.volume;
                if (!((typeof data3 == "number") && (isFinite(data3)))) {
                    const err3 = { instancePath: instancePath + "/video/volume", schemaPath: "#/definitions/Video/properties/volume/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema26.properties.volume.type, parentSchema: schema26.properties.volume, data: data3 };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
            }
            if (data1.loop !== undefined) {
                let data4 = data1.loop;
                if (typeof data4 !== "boolean") {
                    const err4 = { instancePath: instancePath + "/video/loop", schemaPath: "#/definitions/Video/properties/loop/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema26.properties.loop.type, parentSchema: schema26.properties.loop, data: data4 };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            if (data1.playTrigger !== undefined) {
                let data5 = data1.playTrigger;
                if (typeof data5 !== "string") {
                    const err5 = { instancePath: instancePath + "/video/playTrigger", schemaPath: "#/definitions/Video/properties/playTrigger/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema26.properties.playTrigger.type, parentSchema: schema26.properties.playTrigger, data: data5 };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
                if (!(((data5 === "AUTO") || (data5 === "CLICK")) || (data5 === "HOVER"))) {
                    const err6 = { instancePath: instancePath + "/video/playTrigger", schemaPath: "#/definitions/Video/properties/playTrigger/enum", keyword: "enum", params: { allowedValues: schema26.properties.playTrigger.enum }, message: "must be equal to one of the allowed values", schema: schema26.properties.playTrigger.enum, parentSchema: schema26.properties.playTrigger, data: data5 };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
            }
            if (data1.enablePlayButton !== undefined) {
                let data6 = data1.enablePlayButton;
                if (typeof data6 !== "boolean") {
                    const err7 = { instancePath: instancePath + "/video/enablePlayButton", schemaPath: "#/definitions/Video/properties/enablePlayButton/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema26.properties.enablePlayButton.type, parentSchema: schema26.properties.enablePlayButton, data: data6 };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                }
            }
            if (data1.enableThumbnailsPlayButton !== undefined) {
                let data7 = data1.enableThumbnailsPlayButton;
                if (typeof data7 !== "boolean") {
                    const err8 = { instancePath: instancePath + "/video/enableThumbnailsPlayButton", schemaPath: "#/definitions/Video/properties/enableThumbnailsPlayButton/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema26.properties.enableThumbnailsPlayButton.type, parentSchema: schema26.properties.enableThumbnailsPlayButton, data: data7 };
                    if (vErrors === null) {
                        vErrors = [err8];
                    }
                    else {
                        vErrors.push(err8);
                    }
                    errors++;
                }
            }
            if (data1.enableControls !== undefined) {
                let data8 = data1.enableControls;
                if (typeof data8 !== "boolean") {
                    const err9 = { instancePath: instancePath + "/video/enableControls", schemaPath: "#/definitions/Video/properties/enableControls/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema26.properties.enableControls.type, parentSchema: schema26.properties.enableControls, data: data8 };
                    if (vErrors === null) {
                        vErrors = [err9];
                    }
                    else {
                        vErrors.push(err9);
                    }
                    errors++;
                }
            }
            if (data1.enablePlaceholder !== undefined) {
                let data9 = data1.enablePlaceholder;
                if (typeof data9 !== "boolean") {
                    const err10 = { instancePath: instancePath + "/video/enablePlaceholder", schemaPath: "#/definitions/Video/properties/enablePlaceholder/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema26.properties.enablePlaceholder.type, parentSchema: schema26.properties.enablePlaceholder, data: data9 };
                    if (vErrors === null) {
                        vErrors = [err10];
                    }
                    else {
                        vErrors.push(err10);
                    }
                    errors++;
                }
            }
        }
        else {
            const err11 = { instancePath: instancePath + "/video", schemaPath: "#/definitions/Video/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema26.type, parentSchema: schema26, data: data1 };
            if (vErrors === null) {
                vErrors = [err11];
            }
            else {
                vErrors.push(err11);
            }
            errors++;
        }
    }
    if (data.threeDimensionalScene !== undefined) {
        if (!(validate21(data.threeDimensionalScene, { instancePath: instancePath + "/threeDimensionalScene", parentData: data, parentDataProperty: "threeDimensionalScene", rootData }))) {
            vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
            errors = vErrors.length;
        }
    }
    if (data.overlay !== undefined) {
        let data11 = data.overlay;
        if (data11 && typeof data11 == "object" && !Array.isArray(data11)) {
            if (data11.hoveringBehaviour !== undefined) {
                let data12 = data11.hoveringBehaviour;
                if (typeof data12 !== "string") {
                    const err12 = { instancePath: instancePath + "/overlay/hoveringBehaviour", schemaPath: "#/definitions/Overlay/properties/hoveringBehaviour/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema30.properties.hoveringBehaviour.type, parentSchema: schema30.properties.hoveringBehaviour, data: data12 };
                    if (vErrors === null) {
                        vErrors = [err12];
                    }
                    else {
                        vErrors.push(err12);
                    }
                    errors++;
                }
                if (!((((data12 === "ALWAYS_SHOW") || (data12 === "APPEARS")) || (data12 === "DISAPPEARS")) || (data12 === "NEVER_SHOW"))) {
                    const err13 = { instancePath: instancePath + "/overlay/hoveringBehaviour", schemaPath: "#/definitions/Overlay/properties/hoveringBehaviour/enum", keyword: "enum", params: { allowedValues: schema30.properties.hoveringBehaviour.enum }, message: "must be equal to one of the allowed values", schema: schema30.properties.hoveringBehaviour.enum, parentSchema: schema30.properties.hoveringBehaviour, data: data12 };
                    if (vErrors === null) {
                        vErrors = [err13];
                    }
                    else {
                        vErrors.push(err13);
                    }
                    errors++;
                }
            }
            if (data11.hoverAnimation !== undefined) {
                let data13 = data11.hoverAnimation;
                if (typeof data13 !== "string") {
                    const err14 = { instancePath: instancePath + "/overlay/hoverAnimation", schemaPath: "#/definitions/Overlay/properties/hoverAnimation/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema30.properties.hoverAnimation.type, parentSchema: schema30.properties.hoverAnimation, data: data13 };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
                if (!(((((((data13 === "EXPAND") || (data13 === "FADE_IN")) || (data13 === "NO_EFFECT")) || (data13 === "SLIDE_DOWN")) || (data13 === "SLIDE_LEFT")) || (data13 === "SLIDE_RIGHT")) || (data13 === "SLIDE_UP"))) {
                    const err15 = { instancePath: instancePath + "/overlay/hoverAnimation", schemaPath: "#/definitions/Overlay/properties/hoverAnimation/enum", keyword: "enum", params: { allowedValues: schema30.properties.hoverAnimation.enum }, message: "must be equal to one of the allowed values", schema: schema30.properties.hoverAnimation.enum, parentSchema: schema30.properties.hoverAnimation, data: data13 };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            if (data11.position !== undefined) {
                let data14 = data11.position;
                if (typeof data14 !== "string") {
                    const err16 = { instancePath: instancePath + "/overlay/position", schemaPath: "#/definitions/Overlay/properties/position/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema30.properties.position.type, parentSchema: schema30.properties.position, data: data14 };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
                if (!((((((data14 === "BUTTOM") || (data14 === "CENTERED_HORIZONTALLY")) || (data14 === "CENTERED_VERTICALLY")) || (data14 === "LEFT")) || (data14 === "RIGHT")) || (data14 === "TOP"))) {
                    const err17 = { instancePath: instancePath + "/overlay/position", schemaPath: "#/definitions/Overlay/properties/position/enum", keyword: "enum", params: { allowedValues: schema30.properties.position.enum }, message: "must be equal to one of the allowed values", schema: schema30.properties.position.enum, parentSchema: schema30.properties.position, data: data14 };
                    if (vErrors === null) {
                        vErrors = [err17];
                    }
                    else {
                        vErrors.push(err17);
                    }
                    errors++;
                }
            }
            if (data11.size !== undefined) {
                let data15 = data11.size;
                if (!((typeof data15 == "number") && (isFinite(data15)))) {
                    const err18 = { instancePath: instancePath + "/overlay/size", schemaPath: "#/definitions/Overlay/properties/size/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema30.properties.size.type, parentSchema: schema30.properties.size, data: data15 };
                    if (vErrors === null) {
                        vErrors = [err18];
                    }
                    else {
                        vErrors.push(err18);
                    }
                    errors++;
                }
            }
            if (data11.sizeUnits !== undefined) {
                let data16 = data11.sizeUnits;
                if (typeof data16 !== "string") {
                    const err19 = { instancePath: instancePath + "/overlay/sizeUnits", schemaPath: "#/definitions/Overlay/properties/sizeUnits/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema30.properties.sizeUnits.type, parentSchema: schema30.properties.sizeUnits, data: data16 };
                    if (vErrors === null) {
                        vErrors = [err19];
                    }
                    else {
                        vErrors.push(err19);
                    }
                    errors++;
                }
                if (!((data16 === "PERCENT") || (data16 === "PIXEL"))) {
                    const err20 = { instancePath: instancePath + "/overlay/sizeUnits", schemaPath: "#/definitions/Overlay/properties/sizeUnits/enum", keyword: "enum", params: { allowedValues: schema30.properties.sizeUnits.enum }, message: "must be equal to one of the allowed values", schema: schema30.properties.sizeUnits.enum, parentSchema: schema30.properties.sizeUnits, data: data16 };
                    if (vErrors === null) {
                        vErrors = [err20];
                    }
                    else {
                        vErrors.push(err20);
                    }
                    errors++;
                }
            }
            if (data11.padding !== undefined) {
                let data17 = data11.padding;
                if (!((typeof data17 == "number") && (isFinite(data17)))) {
                    const err21 = { instancePath: instancePath + "/overlay/padding", schemaPath: "#/definitions/Overlay/properties/padding/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema30.properties.padding.type, parentSchema: schema30.properties.padding, data: data17 };
                    if (vErrors === null) {
                        vErrors = [err21];
                    }
                    else {
                        vErrors.push(err21);
                    }
                    errors++;
                }
            }
        }
        else {
            const err22 = { instancePath: instancePath + "/overlay", schemaPath: "#/definitions/Overlay/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema30.type, parentSchema: schema30, data: data11 };
            if (vErrors === null) {
                vErrors = [err22];
            }
            else {
                vErrors.push(err22);
            }
            errors++;
        }
    }
    if (data.content !== undefined) {
        let data18 = data.content;
        if (data18 && typeof data18 == "object" && !Array.isArray(data18)) {
            if (data18.hoverAnimation !== undefined) {
                let data19 = data18.hoverAnimation;
                if (typeof data19 !== "string") {
                    const err23 = { instancePath: instancePath + "/content/hoverAnimation", schemaPath: "#/definitions/Content/properties/hoverAnimation/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema31.properties.hoverAnimation.type, parentSchema: schema31.properties.hoverAnimation, data: data19 };
                    if (vErrors === null) {
                        vErrors = [err23];
                    }
                    else {
                        vErrors.push(err23);
                    }
                    errors++;
                }
                if (!(((((((((data19 === "BLUR") || (data19 === "COLOR_IN")) || (data19 === "DARKENED")) || (data19 === "GRAYSCALE")) || (data19 === "INVERT")) || (data19 === "NO_EFFECT")) || (data19 === "SHRINK")) || (data19 === "TILT")) || (data19 === "ZOOM_IN"))) {
                    const err24 = { instancePath: instancePath + "/content/hoverAnimation", schemaPath: "#/definitions/Content/properties/hoverAnimation/enum", keyword: "enum", params: { allowedValues: schema31.properties.hoverAnimation.enum }, message: "must be equal to one of the allowed values", schema: schema31.properties.hoverAnimation.enum, parentSchema: schema31.properties.hoverAnimation, data: data19 };
                    if (vErrors === null) {
                        vErrors = [err24];
                    }
                    else {
                        vErrors.push(err24);
                    }
                    errors++;
                }
            }
            if (data18.placementAnimation !== undefined) {
                let data20 = data18.placementAnimation;
                if (typeof data20 !== "string") {
                    const err25 = { instancePath: instancePath + "/content/placementAnimation", schemaPath: "#/definitions/Content/properties/placementAnimation/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema31.properties.placementAnimation.type, parentSchema: schema31.properties.placementAnimation, data: data20 };
                    if (vErrors === null) {
                        vErrors = [err25];
                    }
                    else {
                        vErrors.push(err25);
                    }
                    errors++;
                }
                if (!((data20 === "NO_EFFECT") || (data20 === "SLIDE"))) {
                    const err26 = { instancePath: instancePath + "/content/placementAnimation", schemaPath: "#/definitions/Content/properties/placementAnimation/enum", keyword: "enum", params: { allowedValues: schema31.properties.placementAnimation.enum }, message: "must be equal to one of the allowed values", schema: schema31.properties.placementAnimation.enum, parentSchema: schema31.properties.placementAnimation, data: data20 };
                    if (vErrors === null) {
                        vErrors = [err26];
                    }
                    else {
                        vErrors.push(err26);
                    }
                    errors++;
                }
            }
            if (data18.loader !== undefined) {
                let data21 = data18.loader;
                if (typeof data21 !== "string") {
                    const err27 = { instancePath: instancePath + "/content/loader", schemaPath: "#/definitions/Content/properties/loader/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema31.properties.loader.type, parentSchema: schema31.properties.loader, data: data21 };
                    if (vErrors === null) {
                        vErrors = [err27];
                    }
                    else {
                        vErrors.push(err27);
                    }
                    errors++;
                }
                if (!(((data21 === "BLUR") || (data21 === "COLOR")) || (data21 === "MAIN_COLOR"))) {
                    const err28 = { instancePath: instancePath + "/content/loader", schemaPath: "#/definitions/Content/properties/loader/enum", keyword: "enum", params: { allowedValues: schema31.properties.loader.enum }, message: "must be equal to one of the allowed values", schema: schema31.properties.loader.enum, parentSchema: schema31.properties.loader, data: data21 };
                    if (vErrors === null) {
                        vErrors = [err28];
                    }
                    else {
                        vErrors.push(err28);
                    }
                    errors++;
                }
            }
            if (data18.magnificationValue !== undefined) {
                let data22 = data18.magnificationValue;
                if (!((typeof data22 == "number") && (isFinite(data22)))) {
                    const err29 = { instancePath: instancePath + "/content/magnificationValue", schemaPath: "#/definitions/Content/properties/magnificationValue/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema31.properties.magnificationValue.type, parentSchema: schema31.properties.magnificationValue, data: data22 };
                    if (vErrors === null) {
                        vErrors = [err29];
                    }
                    else {
                        vErrors.push(err29);
                    }
                    errors++;
                }
            }
            if (data18.tiltAngleValue !== undefined) {
                let data23 = data18.tiltAngleValue;
                if (!((typeof data23 == "number") && (isFinite(data23)))) {
                    const err30 = { instancePath: instancePath + "/content/tiltAngleValue", schemaPath: "#/definitions/Content/properties/tiltAngleValue/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema31.properties.tiltAngleValue.type, parentSchema: schema31.properties.tiltAngleValue, data: data23 };
                    if (vErrors === null) {
                        vErrors = [err30];
                    }
                    else {
                        vErrors.push(err30);
                    }
                    errors++;
                }
            }
        }
        else {
            const err31 = { instancePath: instancePath + "/content", schemaPath: "#/definitions/Content/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema31.type, parentSchema: schema31, data: data18 };
            if (vErrors === null) {
                vErrors = [err31];
            }
            else {
                vErrors.push(err31);
            }
            errors++;
        }
    }
    if (data.secondaryMedia !== undefined) {
        let data24 = data.secondaryMedia;
        if (data24 && typeof data24 == "object" && !Array.isArray(data24)) {
            if (data24.behaviour === undefined) {
                const err32 = { instancePath: instancePath + "/secondaryMedia", schemaPath: "#/definitions/SecondaryMedia/required", keyword: "required", params: { missingProperty: "behaviour" }, message: "must have required property '" + "behaviour" + "'", schema: schema32.required, parentSchema: schema32, data: data24 };
                if (vErrors === null) {
                    vErrors = [err32];
                }
                else {
                    vErrors.push(err32);
                }
                errors++;
            }
            if (data24.trigger === undefined) {
                const err33 = { instancePath: instancePath + "/secondaryMedia", schemaPath: "#/definitions/SecondaryMedia/required", keyword: "required", params: { missingProperty: "trigger" }, message: "must have required property '" + "trigger" + "'", schema: schema32.required, parentSchema: schema32, data: data24 };
                if (vErrors === null) {
                    vErrors = [err33];
                }
                else {
                    vErrors.push(err33);
                }
                errors++;
            }
            if (data24.trigger !== undefined) {
                let data25 = data24.trigger;
                if (typeof data25 !== "string") {
                    const err34 = { instancePath: instancePath + "/secondaryMedia/trigger", schemaPath: "#/definitions/SecondaryMedia/properties/trigger/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema32.properties.trigger.type, parentSchema: schema32.properties.trigger, data: data25 };
                    if (vErrors === null) {
                        vErrors = [err34];
                    }
                    else {
                        vErrors.push(err34);
                    }
                    errors++;
                }
                if (!((data25 === "HOVER") || (data25 === "OFF"))) {
                    const err35 = { instancePath: instancePath + "/secondaryMedia/trigger", schemaPath: "#/definitions/SecondaryMedia/properties/trigger/enum", keyword: "enum", params: { allowedValues: schema32.properties.trigger.enum }, message: "must be equal to one of the allowed values", schema: schema32.properties.trigger.enum, parentSchema: schema32.properties.trigger, data: data25 };
                    if (vErrors === null) {
                        vErrors = [err35];
                    }
                    else {
                        vErrors.push(err35);
                    }
                    errors++;
                }
            }
            if (data24.behaviour !== undefined) {
                let data26 = data24.behaviour;
                if (typeof data26 !== "string") {
                    const err36 = { instancePath: instancePath + "/secondaryMedia/behaviour", schemaPath: "#/definitions/SecondaryMedia/properties/behaviour/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema32.properties.behaviour.type, parentSchema: schema32.properties.behaviour, data: data26 };
                    if (vErrors === null) {
                        vErrors = [err36];
                    }
                    else {
                        vErrors.push(err36);
                    }
                    errors++;
                }
                if ("APPEARS" !== data26) {
                    const err37 = { instancePath: instancePath + "/secondaryMedia/behaviour", schemaPath: "#/definitions/SecondaryMedia/properties/behaviour/const", keyword: "const", params: { allowedValue: "APPEARS" }, message: "must be equal to constant", schema: "APPEARS", parentSchema: schema32.properties.behaviour, data: data26 };
                    if (vErrors === null) {
                        vErrors = [err37];
                    }
                    else {
                        vErrors.push(err37);
                    }
                    errors++;
                }
            }
        }
        else {
            const err38 = { instancePath: instancePath + "/secondaryMedia", schemaPath: "#/definitions/SecondaryMedia/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema32.type, parentSchema: schema32, data: data24 };
            if (vErrors === null) {
                vErrors = [err38];
            }
            else {
                vErrors.push(err38);
            }
            errors++;
        }
    }
}
else {
    const err39 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema25.type, parentSchema: schema25, data };
    if (vErrors === null) {
        vErrors = [err39];
    }
    else {
        vErrors.push(err39);
    }
    errors++;
} validate20.errors = vErrors; return errors === 0; }
const schema33 = { "type": "object", "properties": { "layoutDirection": { "enum": ["LEFT_TO_RIGHT", "RIGHT_TO_LEFT"], "type": "string" }, "blockContextMenu": { "type": "boolean" }, "scrollAnimation": { "enum": ["BLUR", "EXPAND", "FADE_IN", "GRAYSCALE", "MAIN_COLOR", "NO_EFFECT", "ONE_COLOR", "SHRINK", "SLIDE_UP", "ZOOM_OUT"], "type": "string" }, "enableIndexingShareLinks": { "type": "boolean" }, "vertical": { "$ref": "#/definitions/Vertical" }, "horizontal": { "$ref": "#/definitions/Horizontal" } } };
const schema34 = { "type": "object", "properties": { "loadMore": { "$ref": "#/definitions/LoadMore" } } };
const schema35 = { "type": "object", "properties": { "enable": { "type": "boolean" }, "amount": { "enum": ["ALL", "PARTIAL"], "type": "string" }, "text": { "type": "string" } } };
function validate25(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.loadMore !== undefined) {
        let data0 = data.loadMore;
        if (data0 && typeof data0 == "object" && !Array.isArray(data0)) {
            if (data0.enable !== undefined) {
                let data1 = data0.enable;
                if (typeof data1 !== "boolean") {
                    const err0 = { instancePath: instancePath + "/loadMore/enable", schemaPath: "#/definitions/LoadMore/properties/enable/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema35.properties.enable.type, parentSchema: schema35.properties.enable, data: data1 };
                    if (vErrors === null) {
                        vErrors = [err0];
                    }
                    else {
                        vErrors.push(err0);
                    }
                    errors++;
                }
            }
            if (data0.amount !== undefined) {
                let data2 = data0.amount;
                if (typeof data2 !== "string") {
                    const err1 = { instancePath: instancePath + "/loadMore/amount", schemaPath: "#/definitions/LoadMore/properties/amount/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema35.properties.amount.type, parentSchema: schema35.properties.amount, data: data2 };
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
                if (!((data2 === "ALL") || (data2 === "PARTIAL"))) {
                    const err2 = { instancePath: instancePath + "/loadMore/amount", schemaPath: "#/definitions/LoadMore/properties/amount/enum", keyword: "enum", params: { allowedValues: schema35.properties.amount.enum }, message: "must be equal to one of the allowed values", schema: schema35.properties.amount.enum, parentSchema: schema35.properties.amount, data: data2 };
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
            if (data0.text !== undefined) {
                let data3 = data0.text;
                if (typeof data3 !== "string") {
                    const err3 = { instancePath: instancePath + "/loadMore/text", schemaPath: "#/definitions/LoadMore/properties/text/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema35.properties.text.type, parentSchema: schema35.properties.text, data: data3 };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
            }
        }
        else {
            const err4 = { instancePath: instancePath + "/loadMore", schemaPath: "#/definitions/LoadMore/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema35.type, parentSchema: schema35, data: data0 };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
}
else {
    const err5 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema34.type, parentSchema: schema34, data };
    if (vErrors === null) {
        vErrors = [err5];
    }
    else {
        vErrors.push(err5);
    }
    errors++;
} validate25.errors = vErrors; return errors === 0; }
const schema36 = { "type": "object", "properties": { "enableScrollSnap": { "type": "boolean" }, "slideAnimation": { "enum": ["DECK", "FADE", "SCROLL"], "type": "string" }, "slideTransition": { "type": "string" }, "blockScroll": { "type": "boolean" }, "navigationDuration": { "type": "number" }, "loop": { "type": "boolean" }, "autoSlide": { "$ref": "#/definitions/AutoSlide" }, "slideshowInfo": { "$ref": "#/definitions/SlideshowInfo" } } };
const schema37 = { "type": "object", "properties": { "behaviour": { "enum": ["CONTINUOUS", "INTERVAL", "OFF"], "type": "string" }, "interval": { "type": "number" }, "pauseOnHover": { "type": "boolean" }, "speed": { "type": "number" } } };
const schema38 = { "type": "object", "properties": { "buttonsAlignment": { "enum": ["CENTER", "LEFT", "RIGHT"], "type": "string" }, "enableCounter": { "type": "boolean" }, "enablePlayButton": { "type": "boolean" } } };
function validate27(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.enableScrollSnap !== undefined) {
        let data0 = data.enableScrollSnap;
        if (typeof data0 !== "boolean") {
            const err0 = { instancePath: instancePath + "/enableScrollSnap", schemaPath: "#/properties/enableScrollSnap/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema36.properties.enableScrollSnap.type, parentSchema: schema36.properties.enableScrollSnap, data: data0 };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
    }
    if (data.slideAnimation !== undefined) {
        let data1 = data.slideAnimation;
        if (typeof data1 !== "string") {
            const err1 = { instancePath: instancePath + "/slideAnimation", schemaPath: "#/properties/slideAnimation/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema36.properties.slideAnimation.type, parentSchema: schema36.properties.slideAnimation, data: data1 };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
        if (!(((data1 === "DECK") || (data1 === "FADE")) || (data1 === "SCROLL"))) {
            const err2 = { instancePath: instancePath + "/slideAnimation", schemaPath: "#/properties/slideAnimation/enum", keyword: "enum", params: { allowedValues: schema36.properties.slideAnimation.enum }, message: "must be equal to one of the allowed values", schema: schema36.properties.slideAnimation.enum, parentSchema: schema36.properties.slideAnimation, data: data1 };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.slideTransition !== undefined) {
        let data2 = data.slideTransition;
        if (typeof data2 !== "string") {
            const err3 = { instancePath: instancePath + "/slideTransition", schemaPath: "#/properties/slideTransition/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema36.properties.slideTransition.type, parentSchema: schema36.properties.slideTransition, data: data2 };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
        }
    }
    if (data.blockScroll !== undefined) {
        let data3 = data.blockScroll;
        if (typeof data3 !== "boolean") {
            const err4 = { instancePath: instancePath + "/blockScroll", schemaPath: "#/properties/blockScroll/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema36.properties.blockScroll.type, parentSchema: schema36.properties.blockScroll, data: data3 };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    if (data.navigationDuration !== undefined) {
        let data4 = data.navigationDuration;
        if (!((typeof data4 == "number") && (isFinite(data4)))) {
            const err5 = { instancePath: instancePath + "/navigationDuration", schemaPath: "#/properties/navigationDuration/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema36.properties.navigationDuration.type, parentSchema: schema36.properties.navigationDuration, data: data4 };
            if (vErrors === null) {
                vErrors = [err5];
            }
            else {
                vErrors.push(err5);
            }
            errors++;
        }
    }
    if (data.loop !== undefined) {
        let data5 = data.loop;
        if (typeof data5 !== "boolean") {
            const err6 = { instancePath: instancePath + "/loop", schemaPath: "#/properties/loop/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema36.properties.loop.type, parentSchema: schema36.properties.loop, data: data5 };
            if (vErrors === null) {
                vErrors = [err6];
            }
            else {
                vErrors.push(err6);
            }
            errors++;
        }
    }
    if (data.autoSlide !== undefined) {
        let data6 = data.autoSlide;
        if (data6 && typeof data6 == "object" && !Array.isArray(data6)) {
            if (data6.behaviour !== undefined) {
                let data7 = data6.behaviour;
                if (typeof data7 !== "string") {
                    const err7 = { instancePath: instancePath + "/autoSlide/behaviour", schemaPath: "#/definitions/AutoSlide/properties/behaviour/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema37.properties.behaviour.type, parentSchema: schema37.properties.behaviour, data: data7 };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                }
                if (!(((data7 === "CONTINUOUS") || (data7 === "INTERVAL")) || (data7 === "OFF"))) {
                    const err8 = { instancePath: instancePath + "/autoSlide/behaviour", schemaPath: "#/definitions/AutoSlide/properties/behaviour/enum", keyword: "enum", params: { allowedValues: schema37.properties.behaviour.enum }, message: "must be equal to one of the allowed values", schema: schema37.properties.behaviour.enum, parentSchema: schema37.properties.behaviour, data: data7 };
                    if (vErrors === null) {
                        vErrors = [err8];
                    }
                    else {
                        vErrors.push(err8);
                    }
                    errors++;
                }
            }
            if (data6.interval !== undefined) {
                let data8 = data6.interval;
                if (!((typeof data8 == "number") && (isFinite(data8)))) {
                    const err9 = { instancePath: instancePath + "/autoSlide/interval", schemaPath: "#/definitions/AutoSlide/properties/interval/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema37.properties.interval.type, parentSchema: schema37.properties.interval, data: data8 };
                    if (vErrors === null) {
                        vErrors = [err9];
                    }
                    else {
                        vErrors.push(err9);
                    }
                    errors++;
                }
            }
            if (data6.pauseOnHover !== undefined) {
                let data9 = data6.pauseOnHover;
                if (typeof data9 !== "boolean") {
                    const err10 = { instancePath: instancePath + "/autoSlide/pauseOnHover", schemaPath: "#/definitions/AutoSlide/properties/pauseOnHover/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema37.properties.pauseOnHover.type, parentSchema: schema37.properties.pauseOnHover, data: data9 };
                    if (vErrors === null) {
                        vErrors = [err10];
                    }
                    else {
                        vErrors.push(err10);
                    }
                    errors++;
                }
            }
            if (data6.speed !== undefined) {
                let data10 = data6.speed;
                if (!((typeof data10 == "number") && (isFinite(data10)))) {
                    const err11 = { instancePath: instancePath + "/autoSlide/speed", schemaPath: "#/definitions/AutoSlide/properties/speed/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema37.properties.speed.type, parentSchema: schema37.properties.speed, data: data10 };
                    if (vErrors === null) {
                        vErrors = [err11];
                    }
                    else {
                        vErrors.push(err11);
                    }
                    errors++;
                }
            }
        }
        else {
            const err12 = { instancePath: instancePath + "/autoSlide", schemaPath: "#/definitions/AutoSlide/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema37.type, parentSchema: schema37, data: data6 };
            if (vErrors === null) {
                vErrors = [err12];
            }
            else {
                vErrors.push(err12);
            }
            errors++;
        }
    }
    if (data.slideshowInfo !== undefined) {
        let data11 = data.slideshowInfo;
        if (data11 && typeof data11 == "object" && !Array.isArray(data11)) {
            if (data11.buttonsAlignment !== undefined) {
                let data12 = data11.buttonsAlignment;
                if (typeof data12 !== "string") {
                    const err13 = { instancePath: instancePath + "/slideshowInfo/buttonsAlignment", schemaPath: "#/definitions/SlideshowInfo/properties/buttonsAlignment/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema38.properties.buttonsAlignment.type, parentSchema: schema38.properties.buttonsAlignment, data: data12 };
                    if (vErrors === null) {
                        vErrors = [err13];
                    }
                    else {
                        vErrors.push(err13);
                    }
                    errors++;
                }
                if (!(((data12 === "CENTER") || (data12 === "LEFT")) || (data12 === "RIGHT"))) {
                    const err14 = { instancePath: instancePath + "/slideshowInfo/buttonsAlignment", schemaPath: "#/definitions/SlideshowInfo/properties/buttonsAlignment/enum", keyword: "enum", params: { allowedValues: schema38.properties.buttonsAlignment.enum }, message: "must be equal to one of the allowed values", schema: schema38.properties.buttonsAlignment.enum, parentSchema: schema38.properties.buttonsAlignment, data: data12 };
                    if (vErrors === null) {
                        vErrors = [err14];
                    }
                    else {
                        vErrors.push(err14);
                    }
                    errors++;
                }
            }
            if (data11.enableCounter !== undefined) {
                let data13 = data11.enableCounter;
                if (typeof data13 !== "boolean") {
                    const err15 = { instancePath: instancePath + "/slideshowInfo/enableCounter", schemaPath: "#/definitions/SlideshowInfo/properties/enableCounter/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema38.properties.enableCounter.type, parentSchema: schema38.properties.enableCounter, data: data13 };
                    if (vErrors === null) {
                        vErrors = [err15];
                    }
                    else {
                        vErrors.push(err15);
                    }
                    errors++;
                }
            }
            if (data11.enablePlayButton !== undefined) {
                let data14 = data11.enablePlayButton;
                if (typeof data14 !== "boolean") {
                    const err16 = { instancePath: instancePath + "/slideshowInfo/enablePlayButton", schemaPath: "#/definitions/SlideshowInfo/properties/enablePlayButton/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema38.properties.enablePlayButton.type, parentSchema: schema38.properties.enablePlayButton, data: data14 };
                    if (vErrors === null) {
                        vErrors = [err16];
                    }
                    else {
                        vErrors.push(err16);
                    }
                    errors++;
                }
            }
        }
        else {
            const err17 = { instancePath: instancePath + "/slideshowInfo", schemaPath: "#/definitions/SlideshowInfo/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema38.type, parentSchema: schema38, data: data11 };
            if (vErrors === null) {
                vErrors = [err17];
            }
            else {
                vErrors.push(err17);
            }
            errors++;
        }
    }
}
else {
    const err18 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema36.type, parentSchema: schema36, data };
    if (vErrors === null) {
        vErrors = [err18];
    }
    else {
        vErrors.push(err18);
    }
    errors++;
} validate27.errors = vErrors; return errors === 0; }
function validate24(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.layoutDirection !== undefined) {
        let data0 = data.layoutDirection;
        if (typeof data0 !== "string") {
            const err0 = { instancePath: instancePath + "/layoutDirection", schemaPath: "#/properties/layoutDirection/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema33.properties.layoutDirection.type, parentSchema: schema33.properties.layoutDirection, data: data0 };
            if (vErrors === null) {
                vErrors = [err0];
            }
            else {
                vErrors.push(err0);
            }
            errors++;
        }
        if (!((data0 === "LEFT_TO_RIGHT") || (data0 === "RIGHT_TO_LEFT"))) {
            const err1 = { instancePath: instancePath + "/layoutDirection", schemaPath: "#/properties/layoutDirection/enum", keyword: "enum", params: { allowedValues: schema33.properties.layoutDirection.enum }, message: "must be equal to one of the allowed values", schema: schema33.properties.layoutDirection.enum, parentSchema: schema33.properties.layoutDirection, data: data0 };
            if (vErrors === null) {
                vErrors = [err1];
            }
            else {
                vErrors.push(err1);
            }
            errors++;
        }
    }
    if (data.blockContextMenu !== undefined) {
        let data1 = data.blockContextMenu;
        if (typeof data1 !== "boolean") {
            const err2 = { instancePath: instancePath + "/blockContextMenu", schemaPath: "#/properties/blockContextMenu/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema33.properties.blockContextMenu.type, parentSchema: schema33.properties.blockContextMenu, data: data1 };
            if (vErrors === null) {
                vErrors = [err2];
            }
            else {
                vErrors.push(err2);
            }
            errors++;
        }
    }
    if (data.scrollAnimation !== undefined) {
        let data2 = data.scrollAnimation;
        if (typeof data2 !== "string") {
            const err3 = { instancePath: instancePath + "/scrollAnimation", schemaPath: "#/properties/scrollAnimation/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema33.properties.scrollAnimation.type, parentSchema: schema33.properties.scrollAnimation, data: data2 };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
        }
        if (!((((((((((data2 === "BLUR") || (data2 === "EXPAND")) || (data2 === "FADE_IN")) || (data2 === "GRAYSCALE")) || (data2 === "MAIN_COLOR")) || (data2 === "NO_EFFECT")) || (data2 === "ONE_COLOR")) || (data2 === "SHRINK")) || (data2 === "SLIDE_UP")) || (data2 === "ZOOM_OUT"))) {
            const err4 = { instancePath: instancePath + "/scrollAnimation", schemaPath: "#/properties/scrollAnimation/enum", keyword: "enum", params: { allowedValues: schema33.properties.scrollAnimation.enum }, message: "must be equal to one of the allowed values", schema: schema33.properties.scrollAnimation.enum, parentSchema: schema33.properties.scrollAnimation, data: data2 };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
        }
    }
    if (data.enableIndexingShareLinks !== undefined) {
        let data3 = data.enableIndexingShareLinks;
        if (typeof data3 !== "boolean") {
            const err5 = { instancePath: instancePath + "/enableIndexingShareLinks", schemaPath: "#/properties/enableIndexingShareLinks/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema33.properties.enableIndexingShareLinks.type, parentSchema: schema33.properties.enableIndexingShareLinks, data: data3 };
            if (vErrors === null) {
                vErrors = [err5];
            }
            else {
                vErrors.push(err5);
            }
            errors++;
        }
    }
    if (data.vertical !== undefined) {
        if (!(validate25(data.vertical, { instancePath: instancePath + "/vertical", parentData: data, parentDataProperty: "vertical", rootData }))) {
            vErrors = vErrors === null ? validate25.errors : vErrors.concat(validate25.errors);
            errors = vErrors.length;
        }
    }
    if (data.horizontal !== undefined) {
        if (!(validate27(data.horizontal, { instancePath: instancePath + "/horizontal", parentData: data, parentDataProperty: "horizontal", rootData }))) {
            vErrors = vErrors === null ? validate27.errors : vErrors.concat(validate27.errors);
            errors = vErrors.length;
        }
    }
}
else {
    const err6 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema33.type, parentSchema: schema33, data };
    if (vErrors === null) {
        vErrors = [err6];
    }
    else {
        vErrors.push(err6);
    }
    errors++;
} validate24.errors = vErrors; return errors === 0; }
function validate19(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.item !== undefined) {
        if (!(validate20(data.item, { instancePath: instancePath + "/item", parentData: data, parentDataProperty: "item", rootData }))) {
            vErrors = vErrors === null ? validate20.errors : vErrors.concat(validate20.errors);
            errors = vErrors.length;
        }
    }
    if (data.gallery !== undefined) {
        if (!(validate24(data.gallery, { instancePath: instancePath + "/gallery", parentData: data, parentDataProperty: "gallery", rootData }))) {
            vErrors = vErrors === null ? validate24.errors : vErrors.concat(validate24.errors);
            errors = vErrors.length;
        }
    }
}
else {
    const err0 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema24.type, parentSchema: schema24, data };
    if (vErrors === null) {
        vErrors = [err0];
    }
    else {
        vErrors.push(err0);
    }
    errors++;
} validate19.errors = vErrors; return errors === 0; }
function validate10(data, { instancePath = "", parentData, parentDataProperty, rootData = data } = {}) { let vErrors = null; let errors = 0; if (data && typeof data == "object" && !Array.isArray(data)) {
    if (data.layoutParams !== undefined) {
        if (!(validate11(data.layoutParams, { instancePath: instancePath + "/layoutParams", parentData: data, parentDataProperty: "layoutParams", rootData }))) {
            vErrors = vErrors === null ? validate11.errors : vErrors.concat(validate11.errors);
            errors = vErrors.length;
        }
    }
    if (data.behaviourParams !== undefined) {
        if (!(validate19(data.behaviourParams, { instancePath: instancePath + "/behaviourParams", parentData: data, parentDataProperty: "behaviourParams", rootData }))) {
            vErrors = vErrors === null ? validate19.errors : vErrors.concat(validate19.errors);
            errors = vErrors.length;
        }
    }
    if (data.stylingParams !== undefined) {
        let data2 = data.stylingParams;
        if (data2 && typeof data2 == "object" && !Array.isArray(data2)) {
            if (data2.arrowsColor !== undefined) {
                let data3 = data2.arrowsColor;
                if (typeof data3 !== "string") {
                    const err0 = { instancePath: instancePath + "/stylingParams/arrowsColor", schemaPath: "#/definitions/StylingParams/properties/arrowsColor/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema39.properties.arrowsColor.type, parentSchema: schema39.properties.arrowsColor, data: data3 };
                    if (vErrors === null) {
                        vErrors = [err0];
                    }
                    else {
                        vErrors.push(err0);
                    }
                    errors++;
                }
            }
            if (data2.itemShadowBlur !== undefined) {
                let data4 = data2.itemShadowBlur;
                if (!((typeof data4 == "number") && (isFinite(data4)))) {
                    const err1 = { instancePath: instancePath + "/stylingParams/itemShadowBlur", schemaPath: "#/definitions/StylingParams/properties/itemShadowBlur/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema39.properties.itemShadowBlur.type, parentSchema: schema39.properties.itemShadowBlur, data: data4 };
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
            if (data2.itemShadowDirection !== undefined) {
                let data5 = data2.itemShadowDirection;
                if (!((typeof data5 == "number") && (isFinite(data5)))) {
                    const err2 = { instancePath: instancePath + "/stylingParams/itemShadowDirection", schemaPath: "#/definitions/StylingParams/properties/itemShadowDirection/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema39.properties.itemShadowDirection.type, parentSchema: schema39.properties.itemShadowDirection, data: data5 };
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
            if (data2.itemShadowOpacityAndColor !== undefined) {
                let data6 = data2.itemShadowOpacityAndColor;
                if (typeof data6 !== "string") {
                    const err3 = { instancePath: instancePath + "/stylingParams/itemShadowOpacityAndColor", schemaPath: "#/definitions/StylingParams/properties/itemShadowOpacityAndColor/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema39.properties.itemShadowOpacityAndColor.type, parentSchema: schema39.properties.itemShadowOpacityAndColor, data: data6 };
                    if (vErrors === null) {
                        vErrors = [err3];
                    }
                    else {
                        vErrors.push(err3);
                    }
                    errors++;
                }
            }
            if (data2.itemShadowSize !== undefined) {
                let data7 = data2.itemShadowSize;
                if (!((typeof data7 == "number") && (isFinite(data7)))) {
                    const err4 = { instancePath: instancePath + "/stylingParams/itemShadowSize", schemaPath: "#/definitions/StylingParams/properties/itemShadowSize/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema39.properties.itemShadowSize.type, parentSchema: schema39.properties.itemShadowSize, data: data7 };
                    if (vErrors === null) {
                        vErrors = [err4];
                    }
                    else {
                        vErrors.push(err4);
                    }
                    errors++;
                }
            }
            if (data2.itemEnableShadow !== undefined) {
                let data8 = data2.itemEnableShadow;
                if (typeof data8 !== "boolean") {
                    const err5 = { instancePath: instancePath + "/stylingParams/itemEnableShadow", schemaPath: "#/definitions/StylingParams/properties/itemEnableShadow/type", keyword: "type", params: { type: "boolean" }, message: "must be boolean", schema: schema39.properties.itemEnableShadow.type, parentSchema: schema39.properties.itemEnableShadow, data: data8 };
                    if (vErrors === null) {
                        vErrors = [err5];
                    }
                    else {
                        vErrors.push(err5);
                    }
                    errors++;
                }
            }
            if (data2.itemBorderRadius !== undefined) {
                let data9 = data2.itemBorderRadius;
                if (!((typeof data9 == "number") && (isFinite(data9)))) {
                    const err6 = { instancePath: instancePath + "/stylingParams/itemBorderRadius", schemaPath: "#/definitions/StylingParams/properties/itemBorderRadius/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema39.properties.itemBorderRadius.type, parentSchema: schema39.properties.itemBorderRadius, data: data9 };
                    if (vErrors === null) {
                        vErrors = [err6];
                    }
                    else {
                        vErrors.push(err6);
                    }
                    errors++;
                }
            }
            if (data2.itemBorderWidth !== undefined) {
                let data10 = data2.itemBorderWidth;
                if (!((typeof data10 == "number") && (isFinite(data10)))) {
                    const err7 = { instancePath: instancePath + "/stylingParams/itemBorderWidth", schemaPath: "#/definitions/StylingParams/properties/itemBorderWidth/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema39.properties.itemBorderWidth.type, parentSchema: schema39.properties.itemBorderWidth, data: data10 };
                    if (vErrors === null) {
                        vErrors = [err7];
                    }
                    else {
                        vErrors.push(err7);
                    }
                    errors++;
                }
            }
            if (data2.itemResolutionMode !== undefined) {
                let data11 = data2.itemResolutionMode;
                if (typeof data11 !== "string") {
                    const err8 = { instancePath: instancePath + "/stylingParams/itemResolutionMode", schemaPath: "#/definitions/StylingParams/properties/itemResolutionMode/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema39.properties.itemResolutionMode.type, parentSchema: schema39.properties.itemResolutionMode, data: data11 };
                    if (vErrors === null) {
                        vErrors = [err8];
                    }
                    else {
                        vErrors.push(err8);
                    }
                    errors++;
                }
                if (!((data11 === "FULL") || (data11 === "SCLAED_DOWN"))) {
                    const err9 = { instancePath: instancePath + "/stylingParams/itemResolutionMode", schemaPath: "#/definitions/StylingParams/properties/itemResolutionMode/enum", keyword: "enum", params: { allowedValues: schema39.properties.itemResolutionMode.enum }, message: "must be equal to one of the allowed values", schema: schema39.properties.itemResolutionMode.enum, parentSchema: schema39.properties.itemResolutionMode, data: data11 };
                    if (vErrors === null) {
                        vErrors = [err9];
                    }
                    else {
                        vErrors.push(err9);
                    }
                    errors++;
                }
            }
        }
        else {
            const err10 = { instancePath: instancePath + "/stylingParams", schemaPath: "#/definitions/StylingParams/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema39.type, parentSchema: schema39, data: data2 };
            if (vErrors === null) {
                vErrors = [err10];
            }
            else {
                vErrors.push(err10);
            }
            errors++;
        }
    }
}
else {
    const err11 = { instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema11.type, parentSchema: schema11, data };
    if (vErrors === null) {
        vErrors = [err11];
    }
    else {
        vErrors.push(err11);
    }
    errors++;
} validate10.errors = vErrors; return errors === 0; }
//# sourceMappingURL=standaloneValidateCode.js.map